
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/**
 * main.js — Main router
 *
 * Detects the current URL and loads the matching module.
 * Single entry point for the whole application.
 */ // Every style comes in through one file, in ITCSS order

/**
 * site-nav.js — Main navigation
 * Handles the mobile menu with full accessibility (ARIA, focus).
 */ class $dd0366221d9f7fe1$var$SiteNav extends HTMLElement {
    connectedCallback() {
        this.render();
        this._bindEvents();
    }
    render() {
        this.innerHTML = `
      <header class="site-nav">
        <div class="container-full site-nav__inner">
          <a href="/" class="site-nav__logo">
            Laura Caballero Garc\xeda \u{2013} Digital Product Designer
          </a>

          <button
            class="site-nav__toggle"
            aria-expanded="false"
            aria-controls="nav-menu"
            aria-label="Open menu"
          >
            <span class="site-nav__toggle-icon" aria-hidden="true"></span>
          </button>

          <nav id="nav-menu" class="site-nav__menu" aria-label="Main">
            <ul class="site-nav__list" role="list">
              <li><a class="site-nav__link" href="/archive/" data-label="Archive">Archive</a></li>
              <li><a class="site-nav__link" href="/about/" data-label="About">About</a></li>
            </ul>
          </nav>
        </div>
      </header>
    `;
    }
    _bindEvents() {
        const toggle = this.querySelector('.site-nav__toggle');
        const menu = this.querySelector('.site-nav__menu');
        const setOpen = (open)=>{
            toggle === null || toggle === void 0 ? void 0 : toggle.setAttribute('aria-expanded', String(open));
            toggle === null || toggle === void 0 ? void 0 : toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
            menu === null || menu === void 0 ? void 0 : menu.classList.toggle('is-open', open);
        };
        const isOpen = ()=>(toggle === null || toggle === void 0 ? void 0 : toggle.getAttribute('aria-expanded')) === 'true';
        toggle === null || toggle === void 0 ? void 0 : toggle.addEventListener('click', ()=>setOpen(!isOpen()));
        // Closes the menu on a click outside
        document.addEventListener('click', (e)=>{
            if (!this.contains(e.target)) setOpen(false);
        });
        // Closes with Escape and returns focus to the button
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && isOpen()) {
                setOpen(false);
                toggle.focus();
            }
        });
        // Marks the active link
        const currentPath = window.location.pathname;
        this.querySelectorAll('.site-nav__link').forEach((link)=>{
            if (link.getAttribute('href') === currentPath) link.setAttribute('aria-current', 'page');
        });
    }
}
customElements.define('site-nav', $dd0366221d9f7fe1$var$SiteNav);


/**
 * site-footer.js
 */ class $17acaea5f3bce6a9$var$SiteFooter extends HTMLElement {
    connectedCallback() {
        const year = new Date().getFullYear();
        this.innerHTML = `
      <footer class="site-footer">
        <div class="container-full site-footer__inner">
          <div class="site-footer__info">
            <p class="site-footer__copy">
              Copyright\xae ${year}
            </p>
            <p aria-hidden="true"> | </p>
            <p><a class="site-footer__link" href="mailto:lauracaballer19@gmail.com">lauracaballer19@gmail.com</a></p>
          </div>

          <p class="site-footer__note">
              Hosted on
              <a class="site-footer__link" href="https://pages.cloudflare.com" rel="noopener noreferrer" target="_blank">Cloudflare Pages</a>
              \u{2014} green hosting
          </p>
          
          <nav class="site-footer__nav" aria-label="Footer">
            <ul class="site-footer__links" role="list">
              <li><a class="site-footer__link" href="https://www.linkedin.com/in/laura-caballero-garcia" rel="noopener noreferrer" target="_blank">LinkedIn</a></li>
              <li><a class="site-footer__link" href="https://www.behance.net/lauracaballero12" rel="noopener noreferrer" target="_blank">Behance</a></li>
              <li><a class="site-footer__link" href="https://github.com/lauracaballerogarcia/portfolio-web" rel="noopener noreferrer" target="_blank">GitHub</a></li>
            </ul>
            <a class="site-footer__up" href="#top">Up<span class="visually-hidden"> (back to top)</span></a>
          </nav>
        </div>
      </footer>
    `;
    }
}
customElements.define('site-footer', $17acaea5f3bce6a9$var$SiteFooter);


/**
 * index.js — Home page
 *
 * Orchestrates data loading, state and rendering.
 * This is the only layer that connects data with the DOM.
 */ /**
 * store.js — Centralised application state
 *
 * Minimal observable pattern. Conceptually equivalent to
 * useState + useEffect (React) or reactive() (Vue).
 * Any framework store can replace it without touching the
 * data layer or the components.
 */ function $15014f4339395dba$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $4da3ed6030d6e6c4$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $15014f4339395dba$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


const $8026bd73ef96f544$var$store = {
    _state: {
        projects: [],
        loading: false,
        error: null
    },
    _listeners: new Set(),
    /** Returns a copy of the state (immutable from outside) */ getState () {
        return (0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, this._state);
    },
    /**
   * Updates the state and notifies every subscriber.
   * @param {Partial<typeof this._state>} patch
   */ setState (patch) {
        this._state = (0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, this._state, patch);
        this._listeners.forEach((fn)=>fn(this._state));
    },
    /**
   * Subscribes a function to the state. Returns an unsubscribe.
   * @param {(state: object) => void} fn
   * @returns {() => void}
   */ subscribe (fn) {
        this._listeners.add(fn);
        return ()=>this._listeners.delete(fn);
    }
};
var $8026bd73ef96f544$export$2e2bcd8739ae039 = $8026bd73ef96f544$var$store;


var $7387a28c2ed353d6$exports = {};
$7387a28c2ed353d6$exports = JSON.parse('[{"id":"07","slug":"senda","title":"Senda","claim":"Humanizing digital payments for seniors.","summary":"Senda is a digital payment solution designed for people over 70 who need to make online transactions securely and easily. It allows users to pay without exposing their main bank account or relying on complex apps, promoting independence and reducing digital exclusion.","tags":["UX","UI","Visual Identity"],"year":"2026","hero":"/media/senda/senda-01-hero.jpg","thumbnail":"/media/senda/senda-01-hero.jpg","featured":true,"type":"case study","timeline":"Sep 2024 \u2013 Jan 2025","roles":["UX Research","Product Design"],"tools":["FigJam","Figma","Maze"],"team":["Laura Caballero Garc\xeda","Elena Ivars Mart\xednez","Andrea Navarro Silla","Elena Ramad\xe1n Mata"],"client":"University project"},{"id":"09","slug":"bloq","title":"Bloq","claim":"Reimagining home audio as a tool for connection.","summary":"Exploraci\xf3n de patrones de dise\xf1o de interfaz que reducen el consumo energ\xe9tico sin comprometer la experiencia de uso.","tags":["Strategy","Branding","UI"],"year":"2026","hero":"/media/bloq/bloq-00-thumbnail.webp","thumbnail":"/media/bloq/bloq-00-thumbnail.webp","featured":true,"type":"case study","timeline":"Sep 2024 \u2013 Jan 2025","roles":["",""],"tools":["Figma","Krea"],"team":["Laura Caballero Garc\xeda","Luca Giordano","Andrea Navarro Silla","Nicol\xe1s Rodr\xedguez Ramos","Isla Pearce Cano"],"client":"University project"},{"id":"08","slug":"hallo","title":"Hallo","summary":"Simplifying energy management for young households.","tags":["UI"],"year":"2026","thumbnail":"/media/senda/senda-01-hero.jpg","featured":false,"type":"case study","timeline":"Sep 2024 \u2013 Jan 2025","roles":["",""],"tools":["Figma","Krea"],"team":["Laura Caballero Garc\xeda","Luca Giordano","Andrea Navarro Silla","Nicol\xe1s Rodr\xedguez Ramos","Isla Pearce Cano"],"client":"University project"},{"id":"06","slug":"parc-central","title":"Parc Central","claim":"Visual Identity for Valencias\u2019s urban green space.","summary":"Valencia\u2019s Parc Central is a vibrant and inclusive urban green space where nature, culture, and sport coexist. Its visual identity uses the exquisite corpse technique, merging independent elements into a dynamic system that reflects the park\u2019s diverse activities and interactions.","tags":["Visual Identity"],"year":"2025","hero":"/media/parc-central/parc-central-01-hero.webp","thumbnail":"/media/parc-central/parc-central-00-thumbnail.webp","featured":true,"type":"work","timeline":"Sep 2024 \u2013 Jan 2025","roles":["",""],"tools":["Adobe Suite","Figma"],"team":["Laura Caballero Garc\xeda","Mariana Birdici","Andrea Donderis Delcamp","Carola Hinojosa Torres","Beatriz Ortiz Monet","Laura Palau"],"client":"University project"},{"id":"05","slug":"editorial-la-dispersa","title":"Editorial La Dispersa","claim":"A toast to the first words of love.","summary":"Xana is an Asturian white wine that combines tradition and finesse. Produced by a small family winery, it transmits the winemaking heritage from generation to generation, preserving its essence while incorporating a subtle renewal. Inspired by the xana nymphs of Asturian folklore, it seeks to awaken romanticism and celebrate the poetry of first feelings.","tags":["Art direction"],"year":"2024","hero":"/media/xana/xana-01-hero.webp","thumbnail":"/media/xana/xana-00-thumbnail.webp","featured":false,"type":"work","timeline":"Sep 2024 \u2013 Jan 2025","roles":["",""],"tools":["Adobe Suite"],"team":["Laura Caballero Garc\xeda","Andrea Donderis Delcamp"],"client":"University project"},{"id":"04","slug":"xana","title":"Xana","claim":"A toast to the first words of love.","summary":"Xana is an Asturian white wine that combines tradition and finesse. Produced by a small family winery, it transmits the winemaking heritage from generation to generation, preserving its essence while incorporating a subtle renewal. Inspired by the xana nymphs of Asturian folklore, it seeks to awaken romanticism and celebrate the poetry of first feelings.","tags":["Art direction"],"year":"2024","hero":"/media/xana/xana-01-hero.webp","thumbnail":"/media/xana/xana-00-thumbnail.webp","featured":false,"type":"work","timeline":"Sep 2024 \u2013 Jan 2025","roles":["",""],"tools":["Adobe Suite"],"team":["Laura Caballero Garc\xeda","Andrea Donderis Delcamp"],"client":"University project"},{"id":"03","slug":"fuv","title":"FUV","claim":"A toast to the first words of love.","summary":"Xana is an Asturian white wine that combines tradition and finesse. Produced by a small family winery, it transmits the winemaking heritage from generation to generation, preserving its essence while incorporating a subtle renewal. Inspired by the xana nymphs of Asturian folklore, it seeks to awaken romanticism and celebrate the poetry of first feelings.","tags":["Art direction"],"year":"2024","hero":"/media/xana/xana-01-hero.webp","thumbnail":"/media/xana/xana-00-thumbnail.webp","featured":false,"type":"work","timeline":"Sep 2024 \u2013 Jan 2025","roles":["",""],"tools":["Adobe Suite"],"team":["Laura Caballero Garc\xeda","Andrea Donderis Delcamp"],"client":"University project"},{"id":"02","slug":"attic","title":"Attic","claim":"A toast to the first words of love.","summary":"Xana is an Asturian white wine that combines tradition and finesse. Produced by a small family winery, it transmits the winemaking heritage from generation to generation, preserving its essence while incorporating a subtle renewal. Inspired by the xana nymphs of Asturian folklore, it seeks to awaken romanticism and celebrate the poetry of first feelings.","tags":["Art direction"],"year":"2024","hero":"/media/xana/xana-01-hero.webp","thumbnail":"/media/xana/xana-00-thumbnail.webp","featured":false,"type":"work","timeline":"Sep 2024 \u2013 Jan 2025","roles":["",""],"tools":["Adobe Suite"],"team":["Laura Caballero Garc\xeda","Andrea Donderis Delcamp"],"client":"University project"},{"id":"01","slug":"blink","title":"Blink","claim":"A motion festival shaped by the movement of the street.","summary":"Blink is a motion design festival inspired by the restless energy of urban life and the speed at which the world unfolds in the blink of an eye. Through overlapping elements, noisy textures, flashes of light and vibrant colours, its visual identity captures the constant movement of the streets across digital and physical touchpoints.","tags":["Art direction","Visual identity","UI"],"year":"2024","hero":"/media/xana/xana-01-hero.webp","thumbnail":"/media/xana/xana-00-thumbnail.webp","featured":true,"type":"work","timeline":"Dec 2023 \u2013 Jan 2024","roles":["Motion Design","Web Design"],"tools":["Adobe Suite","Figma"],"team":["Laura Caballero Garc\xeda","Andrea Donderis Delcamp","Elena Barrachina Barrachina"],"client":"University project"}]');


var $b6861875f722fafb$exports = {};
$b6861875f722fafb$exports = JSON.parse("{\"/media/about/profile.webp\":{\"height\":2880,\"width\":2880,\"widths\":[480,800,1024,1440,1920,2880]},\"/media/bloq/bloq-00-thumbnail.webp\":{\"height\":641,\"width\":1024,\"widths\":[480,800,1024]},\"/media/parc-central/parc-central-00-thumbnail.webp\":{\"height\":641,\"width\":1024,\"widths\":[480,800,1024]},\"/media/parc-central/parc-central-01-hero.webp\":{\"height\":1251,\"width\":2000,\"widths\":[480,800,1024,1440,1920,2000]},\"/media/xana/xana-00-thumbnail.webp\":{\"height\":641,\"width\":1024,\"widths\":[480,800,1024]},\"/media/xana/xana-01-hero.webp\":{\"height\":1251,\"width\":2000,\"widths\":[480,800,1024,1440,1920,2000]},\"/media/xana/xana-02.webp\":{\"height\":1251,\"width\":2000,\"widths\":[480,800,1024,1440,1920,2000]},\"/media/xana/xana-03.webp\":{\"height\":1251,\"width\":1000,\"widths\":[480,800,1000]},\"/media/xana/xana-04.webp\":{\"height\":1251,\"width\":1000,\"widths\":[480,800,1000]},\"/media/xana/xana-05.webp\":{\"height\":1251,\"width\":1000,\"widths\":[480,800,1000]},\"/media/xana/xana-06.webp\":{\"height\":1251,\"width\":1000,\"widths\":[480,800,1000]},\"/media/xana/xana-07.webp\":{\"height\":1200,\"width\":2000,\"widths\":[480,800,1024,1440,1920,2000]},\"/media/xana/xana-08.webp\":{\"height\":1235,\"width\":2000,\"widths\":[480,800,1024,1440,1920,2000]}}");


var $25a11d61f10b4ce2$exports = {};


function $2b29da1550241972$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2b29da1550241972$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $2b29da1550241972$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


/**
 * marked v18.0.5 - a markdown parser
 * Copyright (c) 2018-2026, MarkedJS. (MIT License)
 * Copyright (c) 2011-2018, Christopher Jeffrey. (MIT License)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(g, f) {
    $25a11d61f10b4ce2$exports = f();
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : undefined, function() {
    var _class;
    var exports = {};
    var __exports = exports;
    var module1 = {
        exports: exports
    };
    "use strict";
    var N = Object.defineProperty;
    var Oe = Object.getOwnPropertyDescriptor;
    var we = Object.getOwnPropertyNames;
    var ye = Object.prototype.hasOwnProperty;
    var Pe = (l, e)=>{
        for(var t in e)N(l, t, {
            get: e[t],
            enumerable: !0
        });
    }, Se = (l, e, t, n)=>{
        if (e && typeof e == "object" || typeof e == "function") for (let s of we(e))!ye.call(l, s) && s !== t && N(l, s, {
            get: ()=>e[s],
            enumerable: !(n = Oe(e, s)) || n.enumerable
        });
        return l;
    };
    var $e = (l)=>Se(N({}, "__esModule", {
            value: !0
        }), l);
    var Rt = {};
    Pe(Rt, {
        Hooks: ()=>P,
        Lexer: ()=>x,
        Marked: ()=>C,
        Parser: ()=>b,
        Renderer: ()=>y,
        TextRenderer: ()=>S,
        Tokenizer: ()=>w,
        defaults: ()=>T,
        getDefaults: ()=>_,
        lexer: ()=>bt,
        marked: ()=>g,
        options: ()=>ht,
        parse: ()=>mt,
        parseInline: ()=>ft,
        parser: ()=>xt,
        setOptions: ()=>kt,
        use: ()=>dt,
        walkTokens: ()=>gt
    });
    module1.exports = $e(Rt);
    function _() {
        return {
            async: !1,
            breaks: !1,
            extensions: null,
            gfm: !0,
            hooks: null,
            pedantic: !1,
            renderer: null,
            silent: !1,
            tokenizer: null,
            walkTokens: null
        };
    }
    var T = _();
    function Q(l) {
        T = l;
    }
    var z = {
        exec: ()=>null
    };
    function E(l) {
        let e = [];
        return (t)=>{
            let n = Math.max(0, Math.min(3, t - 1)), s = e[n];
            return s || (s = l(n), e[n] = s), s;
        };
    }
    function d(l, e = "") {
        let t = typeof l == "string" ? l : l.source, n = {
            replace: (s, r)=>{
                let i = typeof r == "string" ? r : r.source;
                return i = i.replace(m.caret, "$1"), t = t.replace(s, i), n;
            },
            getRegex: ()=>new RegExp(t, e)
        };
        return n;
    }
    var Le = ((l = "")=>{
        try {
            return new RegExp("(?<=1)(?<!1)" + l), true;
        } catch (e) {
            return !1;
        }
    })(), m = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] +\S/,
        listReplaceTask: /^\[[ xX]\] +/,
        listTaskCheckbox: /\[[ xX]\]/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: RegExp("[\\p{L}\\p{N}]", "u"),
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (l)=>new RegExp(`^( {0,3}${l})((?:[	 ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: E((l)=>new RegExp(`^ {0,${l}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`)),
        hrRegex: E((l)=>new RegExp(`^ {0,${l}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`)),
        fencesBeginRegex: E((l)=>new RegExp(`^ {0,${l}}(?:\`\`\`|~~~)`)),
        headingBeginRegex: E((l)=>new RegExp(`^ {0,${l}}#`)),
        htmlBeginRegex: E((l)=>new RegExp(`^ {0,${l}}<(?:[a-z].*>|!--)`, "i")),
        blockquoteBeginRegex: E((l)=>new RegExp(`^ {0,${l}}>`))
    }, _e = /^(?:[ \t]*(?:\n|$))+/, ze = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, Me = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, D = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, Ee = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, F = / {0,3}(?:[*+-]|\d{1,9}[.)])/, ae = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, le = d(ae).replace(/bull/g, F).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), Ie = d(ae).replace(/bull/g, F).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), U = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, Ae = /^[^\n]+/, K = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, Ce = d(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", K).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Be = d(/^(bull)([ \t][^\n]*?)?(?:\n|$)/).replace(/bull/g, F).getRegex(), H = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", W = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, De = d("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", W).replace("tag", H).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), ue = d(U).replace("hr", D).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", H).getRegex(), qe = d(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", ue).getRegex(), X = {
        blockquote: qe,
        code: ze,
        def: Ce,
        fences: Me,
        heading: Ee,
        hr: D,
        html: De,
        lheading: le,
        list: Be,
        newline: _e,
        paragraph: ue,
        table: z,
        text: Ae
    }, ie = d("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", D).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", H).getRegex(), ve = (0, $2b29da1550241972$export$71511d61b312f219)((0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, X), {
        lheading: Ie,
        table: ie,
        paragraph: d(U).replace("hr", D).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", ie).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", H).getRegex()
    }), He = (0, $2b29da1550241972$export$71511d61b312f219)((0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, X), {
        html: d(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", W).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: z,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: d(U).replace("hr", D).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", le).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    }), Ze = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, Ge = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, pe = /^( {2,}|\\)\n(?!\s*$)/, Ne = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, I = RegExp("[\\p{P}\\p{S}]", "u"), Z = RegExp("[\\s\\p{P}\\p{S}]", "u"), J = RegExp("[^\\s\\p{P}\\p{S}]", "u"), Qe = d(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, Z).getRegex(), ce = RegExp("(?!~)[\\p{P}\\p{S}]", "u"), je = RegExp("(?!~)[\\s\\p{P}\\p{S}]", "u"), Fe = RegExp("(?:[^\\s\\p{P}\\p{S}]|~)", "u"), Ue = d(/link|precode-code|html/, "g").replace("link", RegExp("\\[(?:[^\\[\\]`]|(?<a>`+)[^`]+\\k<a>(?!`))*?\\]\\((?:\\\\[\\s\\S]|[^\\\\\\(\\)]|\\((?:\\\\[\\s\\S]|[^\\\\\\(\\)])*\\))*\\)")).replace("precode-", Le ? "(?<!`)()" : "(^^|[^`])").replace("code", RegExp("(?<b>`+)[^`]+\\k<b>(?!`)")).replace("html", /<(?! )[^<>]*?>/).getRegex(), he = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, Ke = d(he, "u").replace(/punct/g, I).getRegex(), We = d(he, "u").replace(/punct/g, ce).getRegex(), ke = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", Xe = d(ke, "gu").replace(/notPunctSpace/g, J).replace(/punctSpace/g, Z).replace(/punct/g, I).getRegex(), Je = d(ke, "gu").replace(/notPunctSpace/g, Fe).replace(/punctSpace/g, je).replace(/punct/g, ce).getRegex(), Ve = d("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, J).replace(/punctSpace/g, Z).replace(/punct/g, I).getRegex(), Ye = d(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, I).getRegex(), et = "^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", tt = d(et, "gu").replace(/notPunctSpace/g, J).replace(/punctSpace/g, Z).replace(/punct/g, I).getRegex(), nt = d(/\\(punct)/, "gu").replace(/punct/g, I).getRegex(), rt = d(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), st = d(W).replace("(?:-->|$)", "-->").getRegex(), it = d("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", st).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), v = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/, ot = d(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace("label", v).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), de = d(/^!?\[(label)\]\[(ref)\]/).replace("label", v).replace("ref", K).getRegex(), ge = d(/^!?\[(ref)\](?:\[\])?/).replace("ref", K).getRegex(), at = d("reflink|nolink(?!\\()", "g").replace("reflink", de).replace("nolink", ge).getRegex(), oe = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, V = {
        _backpedal: z,
        anyPunctuation: nt,
        autolink: rt,
        blockSkip: Ue,
        br: pe,
        code: Ge,
        del: z,
        delLDelim: z,
        delRDelim: z,
        emStrongLDelim: Ke,
        emStrongRDelimAst: Xe,
        emStrongRDelimUnd: Ve,
        escape: Ze,
        link: ot,
        nolink: ge,
        punctuation: Qe,
        reflink: de,
        reflinkSearch: at,
        tag: it,
        text: Ne,
        url: z
    }, lt = (0, $2b29da1550241972$export$71511d61b312f219)((0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, V), {
        link: d(/^!?\[(label)\]\((.*?)\)/).replace("label", v).getRegex(),
        reflink: d(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", v).getRegex()
    }), j = (0, $2b29da1550241972$export$71511d61b312f219)((0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, V), {
        emStrongRDelimAst: Je,
        emStrongLDelim: We,
        delLDelim: Ye,
        delRDelim: tt,
        url: d(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("protocol", oe).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
        text: d(/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace("protocol", oe).getRegex()
    }), ut = (0, $2b29da1550241972$export$71511d61b312f219)((0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, j), {
        br: d(pe).replace("{2,}", "*").getRegex(),
        text: d(j.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    }), q = {
        normal: X,
        gfm: ve,
        pedantic: He
    }, A = {
        normal: V,
        gfm: j,
        breaks: ut,
        pedantic: lt
    };
    var pt = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    }, fe = (l)=>pt[l];
    function O(l, e) {
        if (e) {
            if (m.escapeTest.test(l)) return l.replace(m.escapeReplace, fe);
        } else if (m.escapeTestNoEncode.test(l)) return l.replace(m.escapeReplaceNoEncode, fe);
        return l;
    }
    function Y(l) {
        try {
            l = encodeURI(l).replace(m.percentDecode, "%");
        } catch (e) {
            return null;
        }
        return l;
    }
    function ee(l, e) {
        var _n_at;
        let t = l.replace(m.findPipe, (r, i, o)=>{
            let u = !1, a = i;
            for(; --a >= 0 && o[a] === "\\";)u = !u;
            return u ? "|" : " |";
        }), n = t.split(m.splitPipe), s = 0;
        if (n[0].trim() || n.shift(), n.length > 0 && !((_n_at = n.at(-1)) === null || _n_at === void 0 ? void 0 : _n_at.trim()) && n.pop(), e) {
            if (n.length > e) n.splice(e);
            else for(; n.length < e;)n.push("");
        }
        for(; s < n.length; s++)n[s] = n[s].trim().replace(m.slashPipe, "|");
        return n;
    }
    function L(l, e, t) {
        let n = l.length;
        if (n === 0) return "";
        let s = 0;
        for(; s < n;){
            let r = l.charAt(n - s - 1);
            if (r === e && !t) s++;
            else if (r !== e && t) s++;
            else break;
        }
        return l.slice(0, n - s);
    }
    function te(l) {
        let e = l.split(`
`), t = e.length - 1;
        for(; t >= 0 && m.blankLine.test(e[t]);)t--;
        return e.length - t <= 2 ? l : e.slice(0, t + 1).join(`
`);
    }
    function me(l, e) {
        if (l.indexOf(e[1]) === -1) return -1;
        let t = 0;
        for(let n = 0; n < l.length; n++)if (l[n] === "\\") n++;
        else if (l[n] === e[0]) t++;
        else if (l[n] === e[1] && (t--, t < 0)) return n;
        return t > 0 ? -2 : -1;
    }
    function xe(l, e = 0) {
        let t = e, n = "";
        for (let s of l)if (s === "	") {
            let r = 4 - t % 4;
            n += " ".repeat(r), t += r;
        } else n += s, t++;
        return n;
    }
    function be(l, e, t, n, s) {
        let r = e.href, i = e.title || null, o = l[1].replace(s.other.outputLinkReplace, "$1");
        n.state.inLink = !0;
        let u = {
            type: l[0].charAt(0) === "!" ? "image" : "link",
            raw: t,
            href: r,
            title: i,
            text: o,
            tokens: n.inlineTokens(o)
        };
        return n.state.inLink = !1, u;
    }
    function ct(l, e, t) {
        let n = l.match(t.other.indentCodeCompensation);
        if (n === null) return e;
        let s = n[1];
        return e.split(`
`).map((r)=>{
            let i = r.match(t.other.beginningSpace);
            if (i === null) return r;
            let [o] = i;
            return o.length >= s.length ? r.slice(s.length) : r;
        }).join(`
`);
    }
    var w = class {
        space(e) {
            let t = this.rules.block.newline.exec(e);
            if (t && t[0].length > 0) return {
                type: "space",
                raw: t[0]
            };
        }
        code(e) {
            let t = this.rules.block.code.exec(e);
            if (t) {
                let n = this.options.pedantic ? t[0] : te(t[0]), s = n.replace(this.rules.other.codeRemoveIndent, "");
                return {
                    type: "code",
                    raw: n,
                    codeBlockStyle: "indented",
                    text: s
                };
            }
        }
        fences(e) {
            let t = this.rules.block.fences.exec(e);
            if (t) {
                let n = t[0], s = ct(n, t[3] || "", this.rules);
                return {
                    type: "code",
                    raw: n,
                    lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
                    text: s
                };
            }
        }
        heading(e) {
            let t = this.rules.block.heading.exec(e);
            if (t) {
                let n = t[2].trim();
                if (this.rules.other.endingHash.test(n)) {
                    let s = L(n, "#");
                    (this.options.pedantic || !s || this.rules.other.endingSpaceChar.test(s)) && (n = s.trim());
                }
                return {
                    type: "heading",
                    raw: L(t[0], `
`),
                    depth: t[1].length,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        hr(e) {
            let t = this.rules.block.hr.exec(e);
            if (t) return {
                type: "hr",
                raw: L(t[0], `
`)
            };
        }
        blockquote(e) {
            let t = this.rules.block.blockquote.exec(e);
            if (t) {
                let n = L(t[0], `
`).split(`
`), s = "", r = "", i = [];
                for(; n.length > 0;){
                    let o = !1, u = [], a;
                    for(a = 0; a < n.length; a++)if (this.rules.other.blockquoteStart.test(n[a])) u.push(n[a]), o = !0;
                    else if (!o) u.push(n[a]);
                    else break;
                    n = n.slice(a);
                    let c = u.join(`
`), p = c.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
                    s = s ? `${s}
${c}` : c, r = r ? `${r}
${p}` : p;
                    let k = this.lexer.state.top;
                    if (this.lexer.state.top = !0, this.lexer.blockTokens(p, i, !0), this.lexer.state.top = k, n.length === 0) break;
                    let h = i.at(-1);
                    if ((h === null || h === void 0 ? void 0 : h.type) === "code") break;
                    if ((h === null || h === void 0 ? void 0 : h.type) === "blockquote") {
                        let R = h, f = R.raw + `
` + n.join(`
`), $ = this.blockquote(f);
                        i[i.length - 1] = $, s = s.substring(0, s.length - R.raw.length) + $.raw, r = r.substring(0, r.length - R.text.length) + $.text;
                        break;
                    } else if ((h === null || h === void 0 ? void 0 : h.type) === "list") {
                        let R = h, f = R.raw + `
` + n.join(`
`), $ = this.list(f);
                        i[i.length - 1] = $, s = s.substring(0, s.length - h.raw.length) + $.raw, r = r.substring(0, r.length - R.raw.length) + $.raw, n = f.substring(i.at(-1).raw.length).split(`
`);
                        continue;
                    }
                }
                return {
                    type: "blockquote",
                    raw: s,
                    tokens: i,
                    text: r
                };
            }
        }
        list(e) {
            let t = this.rules.block.list.exec(e);
            if (t) {
                let n = t[1].trim(), s = n.length > 1, r = {
                    type: "list",
                    raw: "",
                    ordered: s,
                    start: s ? +n.slice(0, -1) : "",
                    loose: !1,
                    items: []
                };
                n = s ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = s ? n : "[*+-]");
                let i = this.rules.other.listItemRegex(n), o = !1;
                for(; e;){
                    let a = !1, c = "", p = "";
                    if (!(t = i.exec(e)) || this.rules.block.hr.test(e)) break;
                    c = t[0], e = e.substring(c.length);
                    let k = xe(t[2].split(`
`, 1)[0], t[1].length), h = e.split(`
`, 1)[0], R = !k.trim(), f = 0;
                    if (this.options.pedantic ? (f = 2, p = k.trimStart()) : R ? f = t[1].length + 1 : (f = k.search(this.rules.other.nonSpaceChar), f = f > 4 ? 1 : f, p = k.slice(f), f += t[1].length), R && this.rules.other.blankLine.test(h) && (c += h + `
`, e = e.substring(h.length + 1), a = !0), !a) {
                        let $ = this.rules.other.nextBulletRegex(f), ne = this.rules.other.hrRegex(f), re = this.rules.other.fencesBeginRegex(f), se = this.rules.other.headingBeginRegex(f), Re = this.rules.other.htmlBeginRegex(f), Te = this.rules.other.blockquoteBeginRegex(f);
                        for(; e;){
                            let G = e.split(`
`, 1)[0], B;
                            if (h = G, this.options.pedantic ? (h = h.replace(this.rules.other.listReplaceNesting, "  "), B = h) : B = h.replace(this.rules.other.tabCharGlobal, "    "), re.test(h) || se.test(h) || Re.test(h) || Te.test(h) || $.test(h) || ne.test(h)) break;
                            if (B.search(this.rules.other.nonSpaceChar) >= f || !h.trim()) p += `
` + B.slice(f);
                            else {
                                if (R || k.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || re.test(k) || se.test(k) || ne.test(k)) break;
                                p += `
` + h;
                            }
                            R = !h.trim(), c += G + `
`, e = e.substring(G.length + 1), k = B.slice(f);
                        }
                    }
                    r.loose || (o ? r.loose = !0 : this.rules.other.doubleBlankLine.test(c) && (o = !0)), r.items.push({
                        type: "list_item",
                        raw: c,
                        task: !!this.options.gfm && this.rules.other.listIsTask.test(p),
                        loose: !1,
                        text: p,
                        tokens: []
                    }), r.raw += c;
                }
                let u = r.items.at(-1);
                if (u) u.raw = u.raw.trimEnd(), u.text = u.text.trimEnd();
                else return;
                r.raw = r.raw.trimEnd();
                for (let a of r.items){
                    this.lexer.state.top = !1, a.tokens = this.lexer.blockTokens(a.text, []);
                    let c = a.tokens[0];
                    if (a.task && ((c === null || c === void 0 ? void 0 : c.type) === "text" || (c === null || c === void 0 ? void 0 : c.type) === "paragraph")) {
                        a.text = a.text.replace(this.rules.other.listReplaceTask, ""), c.raw = c.raw.replace(this.rules.other.listReplaceTask, ""), c.text = c.text.replace(this.rules.other.listReplaceTask, "");
                        for(let k = this.lexer.inlineQueue.length - 1; k >= 0; k--)if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[k].src)) {
                            this.lexer.inlineQueue[k].src = this.lexer.inlineQueue[k].src.replace(this.rules.other.listReplaceTask, "");
                            break;
                        }
                        let p = this.rules.other.listTaskCheckbox.exec(a.raw);
                        if (p) {
                            let k = {
                                type: "checkbox",
                                raw: p[0] + " ",
                                checked: p[0] !== "[ ]"
                            };
                            a.checked = k.checked, r.loose ? a.tokens[0] && [
                                "paragraph",
                                "text"
                            ].includes(a.tokens[0].type) && "tokens" in a.tokens[0] && a.tokens[0].tokens ? (a.tokens[0].raw = k.raw + a.tokens[0].raw, a.tokens[0].text = k.raw + a.tokens[0].text, a.tokens[0].tokens.unshift(k)) : a.tokens.unshift({
                                type: "paragraph",
                                raw: k.raw,
                                text: k.raw,
                                tokens: [
                                    k
                                ]
                            }) : a.tokens.unshift(k);
                        }
                    } else a.task && (a.task = !1);
                    if (!r.loose) {
                        let p = a.tokens.filter((h)=>h.type === "space"), k = p.length > 0 && p.some((h)=>this.rules.other.anyLine.test(h.raw));
                        r.loose = k;
                    }
                }
                if (r.loose) for (let a of r.items){
                    a.loose = !0;
                    for (let c of a.tokens)c.type === "text" && (c.type = "paragraph");
                }
                return r;
            }
        }
        html(e) {
            let t = this.rules.block.html.exec(e);
            if (t) {
                let n = te(t[0]);
                return {
                    type: "html",
                    block: !0,
                    raw: n,
                    pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
                    text: n
                };
            }
        }
        def(e) {
            let t = this.rules.block.def.exec(e);
            if (t) {
                let n = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), s = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
                return {
                    type: "def",
                    tag: n,
                    raw: L(t[0], `
`),
                    href: s,
                    title: r
                };
            }
        }
        table(e) {
            var _t_;
            let t = this.rules.block.table.exec(e);
            if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
            let n = ee(t[1]), s = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), r = ((_t_ = t[3]) === null || _t_ === void 0 ? void 0 : _t_.trim()) ? t[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], i = {
                type: "table",
                raw: L(t[0], `
`),
                header: [],
                align: [],
                rows: []
            };
            if (n.length === s.length) {
                for (let o of s)this.rules.other.tableAlignRight.test(o) ? i.align.push("right") : this.rules.other.tableAlignCenter.test(o) ? i.align.push("center") : this.rules.other.tableAlignLeft.test(o) ? i.align.push("left") : i.align.push(null);
                for(let o = 0; o < n.length; o++)i.header.push({
                    text: n[o],
                    tokens: this.lexer.inline(n[o]),
                    header: !0,
                    align: i.align[o]
                });
                for (let o of r)i.rows.push(ee(o, i.header.length).map((u, a)=>({
                        text: u,
                        tokens: this.lexer.inline(u),
                        header: !1,
                        align: i.align[a]
                    })));
                return i;
            }
        }
        lheading(e) {
            let t = this.rules.block.lheading.exec(e);
            if (t) {
                let n = t[1].trim();
                return {
                    type: "heading",
                    raw: L(t[0], `
`),
                    depth: t[2].charAt(0) === "=" ? 1 : 2,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        paragraph(e) {
            let t = this.rules.block.paragraph.exec(e);
            if (t) {
                let n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
                return {
                    type: "paragraph",
                    raw: t[0],
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        text(e) {
            let t = this.rules.block.text.exec(e);
            if (t) return {
                type: "text",
                raw: t[0],
                text: t[0],
                tokens: this.lexer.inline(t[0])
            };
        }
        escape(e) {
            let t = this.rules.inline.escape.exec(e);
            if (t) return {
                type: "escape",
                raw: t[0],
                text: t[1]
            };
        }
        tag(e) {
            let t = this.rules.inline.tag.exec(e);
            if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
                type: "html",
                raw: t[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: !1,
                text: t[0]
            };
        }
        link(e) {
            let t = this.rules.inline.link.exec(e);
            if (t) {
                let n = t[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(n)) {
                    if (!this.rules.other.endAngleBracket.test(n)) return;
                    let i = L(n.slice(0, -1), "\\");
                    if ((n.length - i.length) % 2 === 0) return;
                } else {
                    let i = me(t[2], "()");
                    if (i === -2) return;
                    if (i > -1) {
                        let u = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + i;
                        t[2] = t[2].substring(0, i), t[0] = t[0].substring(0, u).trim(), t[3] = "";
                    }
                }
                let s = t[2], r = "";
                if (this.options.pedantic) {
                    let i = this.rules.other.pedanticHrefTitle.exec(s);
                    i && (s = i[1], r = i[3]);
                } else r = t[3] ? t[3].slice(1, -1) : "";
                return s = s.trim(), this.rules.other.startAngleBracket.test(s) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(n) ? s = s.slice(1) : s = s.slice(1, -1)), be(t, {
                    href: s && s.replace(this.rules.inline.anyPunctuation, "$1"),
                    title: r && r.replace(this.rules.inline.anyPunctuation, "$1")
                }, t[0], this.lexer, this.rules);
            }
        }
        reflink(e, t) {
            let n;
            if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
                let s = (n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " "), r = t[s.toLowerCase()];
                if (!r) {
                    let i = n[0].charAt(0);
                    return {
                        type: "text",
                        raw: i,
                        text: i
                    };
                }
                return be(n, r, n[0], this.lexer, this.rules);
            }
        }
        emStrong(e, t, n = "") {
            let s = this.rules.inline.emStrongLDelim.exec(e);
            if (!s || !s[1] && !s[2] && !s[3] && !s[4] || s[4] && n.match(this.rules.other.unicodeAlphaNumeric)) return;
            if (!(s[1] || s[3] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let i = [
                    ...s[0]
                ].length - 1, o, u, a = i, c = 0, p = s[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                for(p.lastIndex = 0, t = t.slice(-1 * e.length + i); (s = p.exec(t)) !== null;){
                    if (o = s[1] || s[2] || s[3] || s[4] || s[5] || s[6], !o) continue;
                    if (u = [
                        ...o
                    ].length, s[3] || s[4]) {
                        a += u;
                        continue;
                    } else if ((s[5] || s[6]) && i % 3 && !((i + u) % 3)) {
                        c += u;
                        continue;
                    }
                    if (a -= u, a > 0) continue;
                    u = Math.min(u, u + a + c);
                    let k = [
                        ...s[0]
                    ][0].length, h = e.slice(0, i + s.index + k + u);
                    if (Math.min(i, u) % 2) {
                        let f = h.slice(1, -1);
                        return {
                            type: "em",
                            raw: h,
                            text: f,
                            tokens: this.lexer.inlineTokens(f)
                        };
                    }
                    let R = h.slice(2, -2);
                    return {
                        type: "strong",
                        raw: h,
                        text: R,
                        tokens: this.lexer.inlineTokens(R)
                    };
                }
            }
        }
        codespan(e) {
            let t = this.rules.inline.code.exec(e);
            if (t) {
                let n = t[2].replace(this.rules.other.newLineCharGlobal, " "), s = this.rules.other.nonSpaceChar.test(n), r = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
                return s && r && (n = n.substring(1, n.length - 1)), {
                    type: "codespan",
                    raw: t[0],
                    text: n
                };
            }
        }
        br(e) {
            let t = this.rules.inline.br.exec(e);
            if (t) return {
                type: "br",
                raw: t[0]
            };
        }
        del(e, t, n = "") {
            let s = this.rules.inline.delLDelim.exec(e);
            if (!s) return;
            if (!(s[1] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let i = [
                    ...s[0]
                ].length - 1, o, u, a = i, c = this.rules.inline.delRDelim;
                for(c.lastIndex = 0, t = t.slice(-1 * e.length + i); (s = c.exec(t)) !== null;){
                    if (o = s[1] || s[2] || s[3] || s[4] || s[5] || s[6], !o || (u = [
                        ...o
                    ].length, u !== i)) continue;
                    if (s[3] || s[4]) {
                        a += u;
                        continue;
                    }
                    if (a -= u, a > 0) continue;
                    u = Math.min(u, u + a);
                    let p = [
                        ...s[0]
                    ][0].length, k = e.slice(0, i + s.index + p + u), h = k.slice(i, -i);
                    return {
                        type: "del",
                        raw: k,
                        text: h,
                        tokens: this.lexer.inlineTokens(h)
                    };
                }
            }
        }
        autolink(e) {
            let t = this.rules.inline.autolink.exec(e);
            if (t) {
                let n, s;
                return t[2] === "@" ? (n = t[1], s = "mailto:" + n) : (n = t[1], s = n), {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: s,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        url(e) {
            let t;
            if (t = this.rules.inline.url.exec(e)) {
                let n, s;
                if (t[2] === "@") n = t[0], s = "mailto:" + n;
                else {
                    var _this_rules_inline__backpedal_exec;
                    let r;
                    var _this_rules_inline__backpedal_exec_;
                    do r = t[0], t[0] = (_this_rules_inline__backpedal_exec_ = (_this_rules_inline__backpedal_exec = this.rules.inline._backpedal.exec(t[0])) === null || _this_rules_inline__backpedal_exec === void 0 ? void 0 : _this_rules_inline__backpedal_exec[0]) !== null && _this_rules_inline__backpedal_exec_ !== void 0 ? _this_rules_inline__backpedal_exec_ : "";
                    while (r !== t[0]);
                    n = t[0], t[1] === "www." ? s = "http://" + t[0] : s = t[0];
                }
                return {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: s,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        inlineText(e) {
            let t = this.rules.inline.text.exec(e);
            if (t) {
                let n = this.lexer.state.inRawBlock;
                return {
                    type: "text",
                    raw: t[0],
                    text: t[0],
                    escaped: n
                };
            }
        }
        constructor(e){
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "options", void 0);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "rules", void 0);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "lexer", void 0);
            this.options = e || T;
        }
    };
    var x = class l {
        static get rules() {
            return {
                block: q,
                inline: A
            };
        }
        static lex(e, t) {
            return new l(t).lex(e);
        }
        static lexInline(e, t) {
            return new l(t).inlineTokens(e);
        }
        lex(e) {
            e = e.replace(m.carriageReturn, `
`), this.blockTokens(e, this.tokens);
            for(let t = 0; t < this.inlineQueue.length; t++){
                let n = this.inlineQueue[t];
                this.inlineTokens(n.src, n.tokens);
            }
            return this.inlineQueue = [], this.tokens;
        }
        blockTokens(e, t = [], n = !1) {
            this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(m.tabCharGlobal, "    ").replace(m.spaceLine, ""));
            let s = 1 / 0;
            for(; e;){
                var _this_options_extensions_block, _this_options_extensions, _this_options_extensions1;
                if (e.length < s) s = e.length;
                else {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
                let r;
                if ((_this_options_extensions = this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_block = _this_options_extensions.block) === null || _this_options_extensions_block === void 0 ? void 0 : _this_options_extensions_block.some((o)=>(r = o.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
                if (r = this.tokenizer.space(e)) {
                    e = e.substring(r.raw.length);
                    let o = t.at(-1);
                    r.raw.length === 1 && o !== void 0 ? o.raw += `
` : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.code(e)) {
                    e = e.substring(r.raw.length);
                    let o = t.at(-1);
                    (o === null || o === void 0 ? void 0 : o.type) === "paragraph" || (o === null || o === void 0 ? void 0 : o.type) === "text" ? (o.raw += (o.raw.endsWith(`
`) ? "" : `
`) + r.raw, o.text += `
` + r.text, this.inlineQueue.at(-1).src = o.text) : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.fences(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.heading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.hr(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.blockquote(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.list(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.html(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.def(e)) {
                    e = e.substring(r.raw.length);
                    let o = t.at(-1);
                    (o === null || o === void 0 ? void 0 : o.type) === "paragraph" || (o === null || o === void 0 ? void 0 : o.type) === "text" ? (o.raw += (o.raw.endsWith(`
`) ? "" : `
`) + r.raw, o.text += `
` + r.raw, this.inlineQueue.at(-1).src = o.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                        href: r.href,
                        title: r.title
                    }, t.push(r));
                    continue;
                }
                if (r = this.tokenizer.table(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.lheading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                let i = e;
                if ((_this_options_extensions1 = this.options.extensions) === null || _this_options_extensions1 === void 0 ? void 0 : _this_options_extensions1.startBlock) {
                    let o = 1 / 0, u = e.slice(1), a;
                    this.options.extensions.startBlock.forEach((c)=>{
                        a = c.call({
                            lexer: this
                        }, u), typeof a == "number" && a >= 0 && (o = Math.min(o, a));
                    }), o < 1 / 0 && o >= 0 && (i = e.substring(0, o + 1));
                }
                if (this.state.top && (r = this.tokenizer.paragraph(i))) {
                    let o = t.at(-1);
                    n && (o === null || o === void 0 ? void 0 : o.type) === "paragraph" ? (o.raw += (o.raw.endsWith(`
`) ? "" : `
`) + r.raw, o.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = o.text) : t.push(r), n = i.length !== e.length, e = e.substring(r.raw.length);
                    continue;
                }
                if (r = this.tokenizer.text(e)) {
                    e = e.substring(r.raw.length);
                    let o = t.at(-1);
                    (o === null || o === void 0 ? void 0 : o.type) === "text" ? (o.raw += (o.raw.endsWith(`
`) ? "" : `
`) + r.raw, o.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = o.text) : t.push(r);
                    continue;
                }
                if (e) {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
            }
            return this.state.top = !0, t;
        }
        inline(e, t = []) {
            return this.inlineQueue.push({
                src: e,
                tokens: t
            }), t;
        }
        inlineTokens(e, t = []) {
            var _this_options_hooks_emStrongMask, _this_options_hooks;
            this.tokenizer.lexer = this;
            let n = e, s = null;
            if (this.tokens.links) {
                let a = Object.keys(this.tokens.links);
                if (a.length > 0) for(; (s = this.tokenizer.rules.inline.reflinkSearch.exec(n)) !== null;)a.includes(s[0].slice(s[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
            }
            for(; (s = this.tokenizer.rules.inline.anyPunctuation.exec(n)) !== null;)n = n.slice(0, s.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            let r;
            for(; (s = this.tokenizer.rules.inline.blockSkip.exec(n)) !== null;)r = s[2] ? s[2].length : 0, n = n.slice(0, s.index + r) + "[" + "a".repeat(s[0].length - r - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            var _this_options_hooks_emStrongMask_call;
            n = (_this_options_hooks_emStrongMask_call = (_this_options_hooks = this.options.hooks) === null || _this_options_hooks === void 0 ? void 0 : (_this_options_hooks_emStrongMask = _this_options_hooks.emStrongMask) === null || _this_options_hooks_emStrongMask === void 0 ? void 0 : _this_options_hooks_emStrongMask.call({
                lexer: this
            }, n)) !== null && _this_options_hooks_emStrongMask_call !== void 0 ? _this_options_hooks_emStrongMask_call : n;
            let i = !1, o = "", u = 1 / 0;
            for(; e;){
                var _this_options_extensions_inline, _this_options_extensions, _this_options_extensions1;
                if (e.length < u) u = e.length;
                else {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
                i || (o = ""), i = !1;
                let a;
                if ((_this_options_extensions = this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_inline = _this_options_extensions.inline) === null || _this_options_extensions_inline === void 0 ? void 0 : _this_options_extensions_inline.some((p)=>(a = p.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(a.raw.length), t.push(a), !0) : !1)) continue;
                if (a = this.tokenizer.escape(e)) {
                    e = e.substring(a.raw.length), t.push(a);
                    continue;
                }
                if (a = this.tokenizer.tag(e)) {
                    e = e.substring(a.raw.length), t.push(a);
                    continue;
                }
                if (a = this.tokenizer.link(e)) {
                    e = e.substring(a.raw.length), t.push(a);
                    continue;
                }
                if (a = this.tokenizer.reflink(e, this.tokens.links)) {
                    e = e.substring(a.raw.length);
                    let p = t.at(-1);
                    a.type === "text" && (p === null || p === void 0 ? void 0 : p.type) === "text" ? (p.raw += a.raw, p.text += a.text) : t.push(a);
                    continue;
                }
                if (a = this.tokenizer.emStrong(e, n, o)) {
                    e = e.substring(a.raw.length), t.push(a);
                    continue;
                }
                if (a = this.tokenizer.codespan(e)) {
                    e = e.substring(a.raw.length), t.push(a);
                    continue;
                }
                if (a = this.tokenizer.br(e)) {
                    e = e.substring(a.raw.length), t.push(a);
                    continue;
                }
                if (a = this.tokenizer.del(e, n, o)) {
                    e = e.substring(a.raw.length), t.push(a);
                    continue;
                }
                if (a = this.tokenizer.autolink(e)) {
                    e = e.substring(a.raw.length), t.push(a);
                    continue;
                }
                if (!this.state.inLink && (a = this.tokenizer.url(e))) {
                    e = e.substring(a.raw.length), t.push(a);
                    continue;
                }
                let c = e;
                if ((_this_options_extensions1 = this.options.extensions) === null || _this_options_extensions1 === void 0 ? void 0 : _this_options_extensions1.startInline) {
                    let p = 1 / 0, k = e.slice(1), h;
                    this.options.extensions.startInline.forEach((R)=>{
                        h = R.call({
                            lexer: this
                        }, k), typeof h == "number" && h >= 0 && (p = Math.min(p, h));
                    }), p < 1 / 0 && p >= 0 && (c = e.substring(0, p + 1));
                }
                if (a = this.tokenizer.inlineText(c)) {
                    e = e.substring(a.raw.length), a.raw.slice(-1) !== "_" && (o = a.raw.slice(-1)), i = !0;
                    let p = t.at(-1);
                    (p === null || p === void 0 ? void 0 : p.type) === "text" ? (p.raw += a.raw, p.text += a.text) : t.push(a);
                    continue;
                }
                if (e) {
                    this.infiniteLoopError(e.charCodeAt(0));
                    break;
                }
            }
            return t;
        }
        infiniteLoopError(e) {
            let t = "Infinite loop on byte: " + e;
            if (this.options.silent) console.error(t);
            else throw new Error(t);
        }
        constructor(e){
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "tokens", void 0);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "options", void 0);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "state", void 0);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "inlineQueue", void 0);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "tokenizer", void 0);
            this.tokens = [], this.tokens.links = Object.create(null), this.options = e || T, this.options.tokenizer = this.options.tokenizer || new w, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
                inLink: !1,
                inRawBlock: !1,
                top: !0
            };
            let t = {
                other: m,
                block: q.normal,
                inline: A.normal
            };
            this.options.pedantic ? (t.block = q.pedantic, t.inline = A.pedantic) : this.options.gfm && (t.block = q.gfm, this.options.breaks ? t.inline = A.breaks : t.inline = A.gfm), this.tokenizer.rules = t;
        }
    };
    var y = class {
        space(e) {
            return "";
        }
        code({ text: e, lang: t, escaped: n }) {
            var _match;
            let s = (_match = (t || "").match(m.notSpaceStart)) === null || _match === void 0 ? void 0 : _match[0], r = e.replace(m.endingNewline, "") + `
`;
            return s ? '<pre><code class="language-' + O(s) + '">' + (n ? r : O(r, !0)) + `</code></pre>
` : "<pre><code>" + (n ? r : O(r, !0)) + `</code></pre>
`;
        }
        blockquote({ tokens: e }) {
            return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
        }
        html({ text: e }) {
            return e;
        }
        def(e) {
            return "";
        }
        heading({ tokens: e, depth: t }) {
            return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
        }
        hr(e) {
            return `<hr>
`;
        }
        list(e) {
            let t = e.ordered, n = e.start, s = "";
            for(let o = 0; o < e.items.length; o++){
                let u = e.items[o];
                s += this.listitem(u);
            }
            let r = t ? "ol" : "ul", i = t && n !== 1 ? ' start="' + n + '"' : "";
            return "<" + r + i + `>
` + s + "</" + r + `>
`;
        }
        listitem(e) {
            return `<li>${this.parser.parse(e.tokens)}</li>
`;
        }
        checkbox({ checked: e }) {
            return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"> ';
        }
        paragraph({ tokens: e }) {
            return `<p>${this.parser.parseInline(e)}</p>
`;
        }
        table(e) {
            let t = "", n = "";
            for(let r = 0; r < e.header.length; r++)n += this.tablecell(e.header[r]);
            t += this.tablerow({
                text: n
            });
            let s = "";
            for(let r = 0; r < e.rows.length; r++){
                let i = e.rows[r];
                n = "";
                for(let o = 0; o < i.length; o++)n += this.tablecell(i[o]);
                s += this.tablerow({
                    text: n
                });
            }
            return s && (s = `<tbody>${s}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + s + `</table>
`;
        }
        tablerow({ text: e }) {
            return `<tr>
${e}</tr>
`;
        }
        tablecell(e) {
            let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
            return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
        }
        strong({ tokens: e }) {
            return `<strong>${this.parser.parseInline(e)}</strong>`;
        }
        em({ tokens: e }) {
            return `<em>${this.parser.parseInline(e)}</em>`;
        }
        codespan({ text: e }) {
            return `<code>${O(e, !0)}</code>`;
        }
        br(e) {
            return "<br>";
        }
        del({ tokens: e }) {
            return `<del>${this.parser.parseInline(e)}</del>`;
        }
        link({ href: e, title: t, tokens: n }) {
            let s = this.parser.parseInline(n), r = Y(e);
            if (r === null) return s;
            e = r;
            let i = '<a href="' + e + '"';
            return t && (i += ' title="' + O(t) + '"'), i += ">" + s + "</a>", i;
        }
        image({ href: e, title: t, text: n, tokens: s }) {
            s && (n = this.parser.parseInline(s, this.parser.textRenderer));
            let r = Y(e);
            if (r === null) return O(n);
            e = r;
            let i = `<img src="${e}" alt="${O(n)}"`;
            return t && (i += ` title="${O(t)}"`), i += ">", i;
        }
        text(e) {
            return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : O(e.text);
        }
        constructor(e){
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "options", void 0);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "parser", void 0);
            this.options = e || T;
        }
    };
    var S = class {
        strong({ text: e }) {
            return e;
        }
        em({ text: e }) {
            return e;
        }
        codespan({ text: e }) {
            return e;
        }
        del({ text: e }) {
            return e;
        }
        html({ text: e }) {
            return e;
        }
        text({ text: e }) {
            return e;
        }
        link({ text: e }) {
            return "" + e;
        }
        image({ text: e }) {
            return "" + e;
        }
        br() {
            return "";
        }
        checkbox({ raw: e }) {
            return e;
        }
    };
    var b = class l {
        static parse(e, t) {
            return new l(t).parse(e);
        }
        static parseInline(e, t) {
            return new l(t).parseInline(e);
        }
        parse(e) {
            this.renderer.parser = this;
            let t = "";
            for(let n = 0; n < e.length; n++){
                var _this_options_extensions_renderers, _this_options_extensions;
                let s = e[n];
                if ((_this_options_extensions = this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_renderers = _this_options_extensions.renderers) === null || _this_options_extensions_renderers === void 0 ? void 0 : _this_options_extensions_renderers[s.type]) {
                    let i = s, o = this.options.extensions.renderers[i.type].call({
                        parser: this
                    }, i);
                    if (o !== !1 || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "def",
                        "paragraph",
                        "text"
                    ].includes(i.type)) {
                        t += o || "";
                        continue;
                    }
                }
                let r = s;
                switch(r.type){
                    case "space":
                        t += this.renderer.space(r);
                        break;
                    case "hr":
                        t += this.renderer.hr(r);
                        break;
                    case "heading":
                        t += this.renderer.heading(r);
                        break;
                    case "code":
                        t += this.renderer.code(r);
                        break;
                    case "table":
                        t += this.renderer.table(r);
                        break;
                    case "blockquote":
                        t += this.renderer.blockquote(r);
                        break;
                    case "list":
                        t += this.renderer.list(r);
                        break;
                    case "checkbox":
                        t += this.renderer.checkbox(r);
                        break;
                    case "html":
                        t += this.renderer.html(r);
                        break;
                    case "def":
                        t += this.renderer.def(r);
                        break;
                    case "paragraph":
                        t += this.renderer.paragraph(r);
                        break;
                    case "text":
                        t += this.renderer.text(r);
                        break;
                    default:
                        {
                            let i = 'Token with "' + r.type + '" type was not found.';
                            if (this.options.silent) return console.error(i), "";
                            throw new Error(i);
                        }
                }
            }
            return t;
        }
        parseInline(e, t = this.renderer) {
            this.renderer.parser = this;
            let n = "";
            for(let s = 0; s < e.length; s++){
                var _this_options_extensions_renderers, _this_options_extensions;
                let r = e[s];
                if ((_this_options_extensions = this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_renderers = _this_options_extensions.renderers) === null || _this_options_extensions_renderers === void 0 ? void 0 : _this_options_extensions_renderers[r.type]) {
                    let o = this.options.extensions.renderers[r.type].call({
                        parser: this
                    }, r);
                    if (o !== !1 || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(r.type)) {
                        n += o || "";
                        continue;
                    }
                }
                let i = r;
                switch(i.type){
                    case "escape":
                        n += t.text(i);
                        break;
                    case "html":
                        n += t.html(i);
                        break;
                    case "link":
                        n += t.link(i);
                        break;
                    case "image":
                        n += t.image(i);
                        break;
                    case "checkbox":
                        n += t.checkbox(i);
                        break;
                    case "strong":
                        n += t.strong(i);
                        break;
                    case "em":
                        n += t.em(i);
                        break;
                    case "codespan":
                        n += t.codespan(i);
                        break;
                    case "br":
                        n += t.br(i);
                        break;
                    case "del":
                        n += t.del(i);
                        break;
                    case "text":
                        n += t.text(i);
                        break;
                    default:
                        {
                            let o = 'Token with "' + i.type + '" type was not found.';
                            if (this.options.silent) return console.error(o), "";
                            throw new Error(o);
                        }
                }
            }
            return n;
        }
        constructor(e){
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "options", void 0);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "renderer", void 0);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "textRenderer", void 0);
            this.options = e || T, this.options.renderer = this.options.renderer || new y, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new S;
        }
    };
    var P = (_class = class {
        preprocess(e) {
            return e;
        }
        postprocess(e) {
            return e;
        }
        processAllTokens(e) {
            return e;
        }
        emStrongMask(e) {
            return e;
        }
        provideLexer(e = this.block) {
            return e ? x.lex : x.lexInline;
        }
        provideParser(e = this.block) {
            return e ? b.parse : b.parseInline;
        }
        constructor(e){
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "options", void 0);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "block", void 0);
            this.options = e || T;
        }
    }, (0, $15014f4339395dba$export$71511d61b312f219)(_class, "passThroughHooks", new Set([
        "preprocess",
        "postprocess",
        "processAllTokens",
        "emStrongMask"
    ])), (0, $15014f4339395dba$export$71511d61b312f219)(_class, "passThroughHooksRespectAsync", new Set([
        "preprocess",
        "postprocess",
        "processAllTokens"
    ])), _class);
    var C = class {
        walkTokens(e, t) {
            let n = [];
            for (let s of e)switch(n = n.concat(t.call(this, s)), s.type){
                case "table":
                    {
                        let r = s;
                        for (let i of r.header)n = n.concat(this.walkTokens(i.tokens, t));
                        for (let i of r.rows)for (let o of i)n = n.concat(this.walkTokens(o.tokens, t));
                        break;
                    }
                case "list":
                    {
                        let r = s;
                        n = n.concat(this.walkTokens(r.items, t));
                        break;
                    }
                default:
                    {
                        var _this_defaults_extensions_childTokens, _this_defaults_extensions;
                        let r = s;
                        ((_this_defaults_extensions = this.defaults.extensions) === null || _this_defaults_extensions === void 0 ? void 0 : (_this_defaults_extensions_childTokens = _this_defaults_extensions.childTokens) === null || _this_defaults_extensions_childTokens === void 0 ? void 0 : _this_defaults_extensions_childTokens[r.type]) ? this.defaults.extensions.childTokens[r.type].forEach((i)=>{
                            let o = r[i].flat(1 / 0);
                            n = n.concat(this.walkTokens(o, t));
                        }) : r.tokens && (n = n.concat(this.walkTokens(r.tokens, t)));
                    }
            }
            return n;
        }
        use(...e) {
            let t = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            return e.forEach((n)=>{
                let s = (0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, n);
                if (s.async = this.defaults.async || s.async || !1, n.extensions && (n.extensions.forEach((r)=>{
                    if (!r.name) throw new Error("extension name required");
                    if ("renderer" in r) {
                        let i = t.renderers[r.name];
                        i ? t.renderers[r.name] = function(...o) {
                            let u = r.renderer.apply(this, o);
                            return u === !1 && (u = i.apply(this, o)), u;
                        } : t.renderers[r.name] = r.renderer;
                    }
                    if ("tokenizer" in r) {
                        if (!r.level || r.level !== "block" && r.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        let i = t[r.level];
                        i ? i.unshift(r.tokenizer) : t[r.level] = [
                            r.tokenizer
                        ], r.start && (r.level === "block" ? t.startBlock ? t.startBlock.push(r.start) : t.startBlock = [
                            r.start
                        ] : r.level === "inline" && (t.startInline ? t.startInline.push(r.start) : t.startInline = [
                            r.start
                        ]));
                    }
                    "childTokens" in r && r.childTokens && (t.childTokens[r.name] = r.childTokens);
                }), s.extensions = t), n.renderer) {
                    let r = this.defaults.renderer || new y(this.defaults);
                    for(let i in n.renderer){
                        if (!(i in r)) throw new Error(`renderer '${i}' does not exist`);
                        if ([
                            "options",
                            "parser"
                        ].includes(i)) continue;
                        let o = i, u = n.renderer[o], a = r[o];
                        r[o] = (...c)=>{
                            let p = u.apply(r, c);
                            return p === !1 && (p = a.apply(r, c)), p || "";
                        };
                    }
                    s.renderer = r;
                }
                if (n.tokenizer) {
                    let r = this.defaults.tokenizer || new w(this.defaults);
                    for(let i in n.tokenizer){
                        if (!(i in r)) throw new Error(`tokenizer '${i}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(i)) continue;
                        let o = i, u = n.tokenizer[o], a = r[o];
                        r[o] = (...c)=>{
                            let p = u.apply(r, c);
                            return p === !1 && (p = a.apply(r, c)), p;
                        };
                    }
                    s.tokenizer = r;
                }
                if (n.hooks) {
                    let r = this.defaults.hooks || new P;
                    for(let i in n.hooks){
                        if (!(i in r)) throw new Error(`hook '${i}' does not exist`);
                        if ([
                            "options",
                            "block"
                        ].includes(i)) continue;
                        let o = i, u = n.hooks[o], a = r[o];
                        P.passThroughHooks.has(i) ? r[o] = (c)=>{
                            if (this.defaults.async && P.passThroughHooksRespectAsync.has(i)) return (async ()=>{
                                let k = await u.call(r, c);
                                return a.call(r, k);
                            })();
                            let p = u.call(r, c);
                            return a.call(r, p);
                        } : r[o] = (...c)=>{
                            if (this.defaults.async) return (async ()=>{
                                let k = await u.apply(r, c);
                                return k === !1 && (k = await a.apply(r, c)), k;
                            })();
                            let p = u.apply(r, c);
                            return p === !1 && (p = a.apply(r, c)), p;
                        };
                    }
                    s.hooks = r;
                }
                if (n.walkTokens) {
                    let r = this.defaults.walkTokens, i = n.walkTokens;
                    s.walkTokens = function(o) {
                        let u = [];
                        return u.push(i.call(this, o)), r && (u = u.concat(r.call(this, o))), u;
                    };
                }
                this.defaults = (0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, this.defaults, s);
            }), this;
        }
        setOptions(e) {
            return this.defaults = (0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, this.defaults, e), this;
        }
        lexer(e, t) {
            return x.lex(e, t !== null && t !== void 0 ? t : this.defaults);
        }
        parser(e, t) {
            return b.parse(e, t !== null && t !== void 0 ? t : this.defaults);
        }
        parseMarkdown(e) {
            return (n, s)=>{
                let r = (0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, s), i = (0, $4da3ed6030d6e6c4$export$71511d61b312f219)({}, this.defaults, r), o = this.onError(!!i.silent, !!i.async);
                if (this.defaults.async === !0 && r.async === !1) return o(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                if (typeof n > "u" || n === null) return o(new Error("marked(): input parameter is undefined or null"));
                if (typeof n != "string") return o(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
                if (i.hooks && (i.hooks.options = i, i.hooks.block = e), i.async) return (async ()=>{
                    let u = i.hooks ? await i.hooks.preprocess(n) : n, c = await (i.hooks ? await i.hooks.provideLexer(e) : e ? x.lex : x.lexInline)(u, i), p = i.hooks ? await i.hooks.processAllTokens(c) : c;
                    i.walkTokens && await Promise.all(this.walkTokens(p, i.walkTokens));
                    let h = await (i.hooks ? await i.hooks.provideParser(e) : e ? b.parse : b.parseInline)(p, i);
                    return i.hooks ? await i.hooks.postprocess(h) : h;
                })().catch(o);
                try {
                    i.hooks && (n = i.hooks.preprocess(n));
                    let a = (i.hooks ? i.hooks.provideLexer(e) : e ? x.lex : x.lexInline)(n, i);
                    i.hooks && (a = i.hooks.processAllTokens(a)), i.walkTokens && this.walkTokens(a, i.walkTokens);
                    let p = (i.hooks ? i.hooks.provideParser(e) : e ? b.parse : b.parseInline)(a, i);
                    return i.hooks && (p = i.hooks.postprocess(p)), p;
                } catch (u) {
                    return o(u);
                }
            };
        }
        onError(e, t) {
            return (n)=>{
                if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                    let s = "<p>An error occurred:</p><pre>" + O(n.message + "", !0) + "</pre>";
                    return t ? Promise.resolve(s) : s;
                }
                if (t) return Promise.reject(n);
                throw n;
            };
        }
        constructor(...e){
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "defaults", _());
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "options", this.setOptions);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "parse", this.parseMarkdown(!0));
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "parseInline", this.parseMarkdown(!1));
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "Parser", b);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "Renderer", y);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "TextRenderer", S);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "Lexer", x);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "Tokenizer", w);
            (0, $15014f4339395dba$export$71511d61b312f219)(this, "Hooks", P);
            this.use(...e);
        }
    };
    var M = new C;
    function g(l, e) {
        return M.parse(l, e);
    }
    g.options = g.setOptions = function(l) {
        return M.setOptions(l), g.defaults = M.defaults, Q(g.defaults), g;
    };
    g.getDefaults = _;
    g.defaults = T;
    g.use = function(...l) {
        return M.use(...l), g.defaults = M.defaults, Q(g.defaults), g;
    };
    g.walkTokens = function(l, e) {
        return M.walkTokens(l, e);
    };
    g.parseInline = M.parseInline;
    g.Parser = b;
    g.parser = b.parse;
    g.Renderer = y;
    g.TextRenderer = S;
    g.Lexer = x;
    g.lexer = x.lex;
    g.Tokenizer = w;
    g.Hooks = P;
    g.parse = g;
    var ht = g.options, kt = g.setOptions, dt = g.use, gt = g.walkTokens, ft = g.parseInline, mt = g, xt = b.parse, bt = x.lex;
    if (__exports != exports) module1.exports = exports;
    return module1.exports;
});


var $a0942e6de8b62304$exports = {};
$a0942e6de8b62304$exports = "<p class=\"case-section__eyebrow\">Context</p>\n\n## Older adults are losing access to the leisure activities that keep them active and connected.\n\n<!-- **Scope of work** -->\n![Project timeline from September to January: UX research (initial hypothesis, desk research, proto-persona, benchmark, interviews), definition (validated hypothesis, problem statement, personas, user journey, concept, strategy), ideation (epics, user stories, flows, sitemap, wireframes, prototyping, usability testing) and UI design (branding, high-fidelity UI, design system, moderated testing).](/media/senda/senda-overview-timeline.svg \"full 1024x480\")\n\n**The brief**\n\n> How might we help people aged 70+ access leisure activities more easily through a digital platform?\n\n**Goal**\n\nHelp older adults participate more independently in leisure activities while creating value for institutions and the wider community.\n\n\n\n\n<p class=\"case-section__eyebrow\">Research</p>\n\n## We assumed the problem was finding activities. Interviews with older adults proved us wrong \n\nThis project arose from identifying the barriers this group faces in digital environments. The lack of accessible tools not only limits their autonomy but also their active participation in daily life.\n\nFollowing an initial brainstorming session, we arrived at an initial hypothesis:\n\n>People over the age of 70 with intellectual interests need a simple way to find affordable activities because they lack a common place they can turn to.\n\nHowever, before moving into solution design, we needed to validate this assumption and understand the underlying problem.\n\n\n### Understanding where digital processes break down\n\nTo address this, we needed a deep understanding of older adults' fears, the barriers they face with technology, and how they experience the digital divide. This involved collecting qualitative data through **in-person interviews** with older adults, which allowed us to gather first-hand insights into their behaviours, motivations, and pain points.\n![Three quotes from interviews with older adults. Mari Carmen, 74: “I prefer to call to make a reservation. If I have to do it online, I call my daughter because I’m not sure how.” Araceli, 73: “I always buy at the ticket office, I don’t know about mobile… I’d like to know how to manage it better and not have to move around so much.” Miguel, 72: “With so many people scamming you these days, I’m scared and I prefer not to take the risk.”](/media/senda/senda-02-research-quotes.svg \"full 1024x496\")\n\n### Insights\nThe findings revealed several key insights, including fear of scams, reliance on family members, digital exclusion, and the loss of opportunities and well-being.\n\n<section class=\"insights\" aria-label=\"Key insights\">\n  <ul class=\"insights__track\" id=\"insightsTrack\" tabindex=\"0\">\n    <li class=\"insight-card\">\n      <p class=\"insight-card__label\">Digital exclusion</p>\n      <div class=\"insight-card__content\">\n        <div class=\"insight-card__stat\">\n          <p class=\"insight-card__percentage\">90%</p>\n          <img class=\"insight-card__icon\" src=\"/media/senda/senda-research-percentage-90.svg\" alt=\"\" width=\"101\" height=\"80\">\n        </div>\n        <p class=\"insight-card__description\">\n          Think that technology is not for them and feel that the world is moving too fast.\n        </p>\n      </div>\n    </li>\n    <li class=\"insight-card\">\n      <p class=\"insight-card__label\">Fear of scams</p>\n      <div class=\"insight-card__content\">\n        <div class=\"insight-card__stat\">\n          <p class=\"insight-card__percentage\">82%</p>\n          <img class=\"insight-card__icon\" src=\"/media/senda/senda-research-percentage-82.svg\" alt=\"\" width=\"160\" height=\"36\">\n        </div>\n        <p class=\"insight-card__description\">\n          Feel insecure and exposed when making online payments due to the numerous scams.\n        </p>\n      </div>\n    </li>\n    <li class=\"insight-card\">\n      <p class=\"insight-card__label\">Dependency</p>\n      <div class=\"insight-card__content\">\n        <div class=\"insight-card__stat\">\n          <p class=\"insight-card__percentage\">76%</p>\n          <img class=\"insight-card__icon\" src=\"/media/senda/senda-research-percentage-76.svg\" alt=\"\" width=\"160\" height=\"80\">\n        </div>\n        <p class=\"insight-card__description\">\n          Depend on family members or third parties to carry out complex digital actions.\n        </p>\n      </div>\n    </li>\n    <li class=\"insight-card\">\n      <p class=\"insight-card__label\">Loss of social opportunities and well-being</p>\n      <div class=\"insight-card__content\">\n        <div class=\"insight-card__stat\">\n          <p class=\"insight-card__percentage\">78%</p>\n          <img class=\"insight-card__icon\" src=\"/media/senda/senda-research-percentage-78.svg\" alt=\"\" width=\"161\" height=\"97\">\n        </div>\n        <p class=\"insight-card__description\">\n          Lose out on social well-being opportunities by being unable to afford certain online procedures.\n        </p>\n      </div>\n    </li>\n  </ul>\n\n  <div class=\"insights__controls\">\n    <button class=\"icon-button insights__arrow\" data-scroll=\"prev\" aria-label=\"Show previous insight\">\n      <!-- SVG flecha izquierda aquí, con aria-hidden=\"true\" -->\n    </button>\n    <button class=\"icon-button insights__arrow\" data-scroll=\"next\" aria-label=\"Show next insight\">\n      <!-- SVG flecha derecha aquí, con aria-hidden=\"true\" -->\n    </button>\n  </div>\n</section>\n\nTogether, these observations pointed towards a broader need: making complex digital processes feel simpler, safer, and more manageable.\n\n\n<p class=\"case-section__eyebrow\">Problem</p>\n\n## It was never about finding activities — it was about feeling safe enough to pay for them\nThe insights showed that the real challenge wasn't finding or signing up for leisure activities, but feeling secure while paying online for them. Users knew where to look for activities that interested them, but the digital payment step was a major setback. \n![Before and after diagram. Before, the MVP covered three opportunities: access to training activities, simpler complex processes and personalised support. After, it narrows to one: simplifying online payments, because if seniors don’t feel confident paying, that has to be solved first.](/media/senda/senda-03-strategic-shift.svg \"full 1024x497\")\n\nThis led us to reframe the original hypothesis into the real problem to solve:\n\n>People over the age of 70 need to make online payments securely, but they do not trust entering their bank card details online and lack simple alternatives that make them feel safe and confident.\n\nFrom this reframed problem, we devised guided solutions, simplified steps, and a more empathetic tone.\n\n\n\n\n<p class=\"case-section__eyebrow\">Solution</p>\n\n## A digital wallet that keeps their main bank account out of the equation\n\nSenda offers an alternative approach to online payments through a digital wallet that can be topped up via the app — by requesting a transfer from a family member or caregiver — or in person at a trusted local store regularly visited by the user. This enables older adults to pay for their own leisure activities without exposing their main bank account or navigating complex banking environments.\n\n### Every interaction was designed to reduce uncertainty\nBased on our research insights, we defined three core design principles that guided every design decision, ensuring the final experience was tailored to users' needs:\n> Empathetic  – Nimble – Reliable\n\n\n### We focused the <abbr title=\"Minimum Viable Product\">MVP</abbr> on the moments where confidence matters most\n\n#### Key features\nBefore designing the user flows, we identified three key features that would shape the user experience: secure payments, hybrid top-ups, and trusted support. These served as the foundation for the app's overall functionality.\n\n![Three key features: safe payments with a limited balance that keeps bank and card details protected; hybrid top-ups, either requested digitally or made in person at trusted locations; and trusted support, receiving funds from approved family members with full transparency.](/media/senda/senda-solution-key-features.svg \"full 785x424\")\n\n#### User Roles\nWe defined two user roles: the Senior, who uses the app to make payments, and the Administrator, a trusted family member or caregiver responsible for managing and topping up the senior's balance. For the <abbr title=\"Minimum Viable Product\">MVP</abbr>, we prioritized the Senior experience, as it represented the app's primary user journey.\n\n![Main user, the senior: low digital confidence, fear of scams, needs reassurance and clarity.](/media/senda/senda-solution-user-role-primary.svg \"half 383x296\")\n![Secondary user, the administrator: higher digital literacy, needs control and oversight, wants security and transparency.](/media/senda/senda-solution-user-role-secondary.svg \"half 383x296\")\n\n\n#### Initial mapping\nThe next step was mapping the happy path for senior users making a payment. We started with the wallet top-up, as it represented users' first interaction with the payment experience and the stage where friction or uncertainty was most likely to occur. It was essential that this initial flow clearly communicated security and built users' confidence from the outset.\n\n![Happy-path flow for topping up the wallet. A user with no balance chooses how to top up: at a physical location, with an introduction, a top-up animation and an updated balance; or by requesting money from an admin, choosing an amount, optionally adding a message, confirming and waiting for approval, followed by a notification.](/media/senda/senda-solution-sitemap.svg \"full 1600x800\")\n\n\n\n<p class=\"case-section__eyebrow\">Testing</p>\n\n## The core flow worked, but physical top-ups created friction\n\n### Test Objectives\n1. Evaluate the usability of the main features\n2. Identify what users would do if they needed help with any process.\n3. Identify which areas users interpret as clickable (e.g., the cards in the list of physical locations or the wallet in the request flow).\n4. Identify whether users would like Senda to provide GPS-like guidance to help them locate the selected physical points.\n\n### User Testing with maze\nTesting was conducted remotely via Maze. The study involved two participant groups*: 11 users (people over 70 with difficulties making online payments) and 14 admins (caregivers who assist elderly users with digital tasks).\n\n<div class=\"case-note\" role=\"note\">\n  <p class=\"case-note__text case-note__label\">Note:</p>\n  <p class=\"case-note__text\">*While the 25-person sample served as a solid exploratory foundation, a statistically representative sample would require 385 participants (5% margin of error, 95% confidence level) to draw conclusive findings at scale.</p>\n</div>\n\n![Maze heatmaps on four prototype screens (wallet, request balance, request summary and physical top-up) showing where participants tapped.](/media/senda/senda-testing-maze.svg \"full 785x420\")\n\nHeatmaps revealed where users tapped during usability testing, helping us assess whether they could easily identify the intended path. They also exposed interaction patterns and areas of confusion, such as misclicks and instances where users selected the wrong element.\n\n### Evaluation\n\n<div class=\"case-evaluation\">\n  <div class=\"case-evaluation__card case-evaluation__card--positive\">\n    <p class=\"case-evaluation__text\">Users are able to request balance without complications.</p>\n  </div>\n  <div class=\"case-evaluation__card case-evaluation__card--negative\">\n    <p class=\"case-evaluation__text\">Users have difficulties when topping up at physical locations.</p>\n  </div>\n  <div class=\"case-evaluation__card case-evaluation__card--negative\">\n    <p class=\"case-evaluation__text\">Users had difficulties finding nearby physical locations.</p>\n  </div>\n  <div class=\"case-evaluation__card case-evaluation__card--negative\">\n    <p class=\"case-evaluation__text\">Administrators have experienced difficulties when approving a top-up request.</p>\n  </div>\n</div>\n\n\n### Iteration & refinement\nBased on these insights, we identified several improvements before moving into the final <abbr title=\"Minimum Viable Product\">MVP</abbr> UI:\n\n1. Redesigning the physical recharge flow to reduce misclicks and improve interaction clarity.\n2. Strengthening UI visuals so tappable elements were more obvious.\n3. Introducing an optional \"Get directions\" button to support real-world navigation.\n4. Adding an assistance flow so users could quickly access help when uncertain.\n\n\n#### Final MVP User Flow\n\n![Final MVP flow for requesting balance through the app: from the home screen, the user picks an amount, adds an optional message, confirms the request and sees that it has been sent. A branch shows cancelling, with a dialog to confirm or go back.](/media/senda/senda-testing-final-flow-1.svg \"full 1981x1470\")\n\n\n<p class=\"case-section__eyebrow\">Outcome</p>\n\n## A simpler payment experience built around trust\n\n\n### Final UI\n\n![An older man holding a phone that shows Senda’s nearest top-up points on a map, with a notification confirming a 30 EUR top-up at a local tobacconist.](/media/senda/senda-outcome-final-ui-physical-top-up.svg \"full 1024x569\")\n\n![Senda’s visual identity: Antonia and Onest typefaces, a dark green, light green and light blue palette, the app icon, a wallet illustration, a map route to a bank and the request summary screen on a phone.](/media/senda/senda-outcome-final-ui-visual-identity.jpg \"full 2048x1269\")\n\n![Animated home screen where the user switches their wallet between green, dark green and blue.](/media/senda/senda-outcome-final-ui-wallets.mp4 \"full 1440x932\")\n\n### Final prototype\n\n#### Request top-up with cash flow\n![Senda splash screen: a hand holding a coin, with the line “Your money. Your peace of mind. Your pace.”](/media/senda/senda-outcome-prototype-flow-request-top-up.svg \"half 383x480\")\n![Senda splash screen: a hand holding a coin, with the line “Your money. Your peace of mind. Your pace.”](/media/senda/senda-outcome-prototype-flow-request-top-up.svg \"half 383x480\")\n\n\n#### Request balance to admin flow\n![Senda splash screen: a hand holding a coin, with the line “Your money. Your peace of mind. Your pace.”](/media/senda/senda-outcome-prototype-flow-request-top-up.svg \"half 383x480\")\n![Senda splash screen: a hand holding a coin, with the line “Your money. Your peace of mind. Your pace.”](/media/senda/senda-outcome-prototype-flow-request-top-up.svg \"half 383x480\")\n\n### Next steps\n1. Introduce a brief, task-oriented onboarding.\n2. Add an optional \"How to get there\" flow for physical locations.\n3. Develop the administrator interface.\n\n\n\n\n<p class=\"case-section__eyebrow\">Reflection</p>\n\n## Designing for confidence means designing beyond the interface\n\n### Projected impact\n \n1. Reducing digital gap and distrust: Current interfaces are not designed for older users; Senda, in contrast, offers an experience tailored to their needs, building trust.\n2. Increasing initiative in online processes: By removing confusion and simplifying steps, users become less afraid of making mistakes and are more willing to engage with technology.\n3. Promoting well-being and inclusion: We enable access to a wide range of activities and experiences for a key user group.\n\n<div class=\"case-note\" role=\"note\">\n  <p class=\"case-note__text case-note__label\">Note:</p>\n  <p class=\"case-note__text\">As part of an academic project, the solution was not validated after launch. In a real-world scenario, success would be measured through metrics such as task completion rate, time on task, user confidence and satisfaction, and increased adoption of digital payments among older adults.</p>\n</div>\n\n\n### Takeaways\n1. Tool choice and test structure impact data quality.\n2. Copywriting directly shapes user understanding and flow.\n3. Confirmation screens build confidence and reduce errors.";


var $679b34a1dc3f6e9c$exports = {};
$679b34a1dc3f6e9c$exports = "![Animation of the Parc Central wordmark, a condensed serif, with its letters enlarged over a construction grid.](/media/parc-central/parc-central-03-identity.mp4 \"full 1440x900\")\n\n## Concept\n\n### The exquisite corpse technique\n\nThe identity builds on this artistic method of collective creation, uniting fragments into a coherent composition. This approach mirrors the park’s diversity of uses and social interactions, generating a flexible, evolving, and dynamic graphic system that adapts to the changing activities and experiences within the space.\n\n\n![Animation of an empty poster grid filling with stacked fragments (wordmark, photography, handwritten slogan and illustrations) to create several poster variations.](/media/parc-central/parc-central-04-posters.mp4 \"full 1440x800\")\n\n![Parc Central poster on a street billboard in Valencia, combining handwritten notes, a photo of the park, the wordmark and the slogan “El teu espai pel que vulguis!”](/media/parc-central/parc-central-05-posters-identity-mockup.jpg \"full 1440x960\")\n\n![Animation of a folding flyer opening to reveal the wordmark, illustrations and a colour-coded index of the park’s areas.](/media/parc-central/parc-central-06-flyer.mp4 \"full 1440x900\")\n\n![Event posters pasted on a wall, announcing educational workshops every Sunday in May about zero waste, saving water and green homes.](/media/parc-central/parc-central-07-posters-events-mockup.gif \"full 1440x900\")\n\n## Visual System\n\nThe system is modular, allowing graphics to shift, overlap, and recombine depending on context—signage, print, digital applications, or event communication. Colors, patterns, and forms are inspired by the park’s natural elements, cultural landmarks, and sporting infrastructure, creating a visual language that feels alive and responsive.\n\n![Kraft box for a birdhouse-building kit, sealed with yellow and pink tape printed with the Parc Central wordmark.](/media/parc-central/parc-central-08-packaging-event.jpg \"half 1536x1840\")\n![Phone showing a digital ticket for a birdhouse-building workshop, with the pink Parc Central header, illustrations, date, time and barcode.](/media/parc-central/parc-central-09-wallet.gif \"half 800x836\")\n\n![Website animation: the Parc Central homepage builds up from the wordmark, then changes colour to highlight the park’s spaces and programme.](/media/parc-central/parc-central-10-web.mp4 \"full 1440x900\")\n\n![Interpretive sign in the park about a Schinus molle tree, with a line illustration and the Parc Central wordmark.](/media/parc-central/parc-central-11-signage-1.jpg \"full 2880x1840\")\n\n![Tall information totem beside a brick and stone building, telling the history of the Ribes industrial building in Valencian and Spanish.](/media/parc-central/parc-central-12-signage-2.jpg \"half 1226x1840\")\n![Colour-coded category tags photographed in the park: grey for services, pink for gardens and orange for squares, each with its hex code.](/media/parc-central/parc-central-13-signage-legend.gif \"half 848x900\")\n\n![Large fabric banners in blue, pink with the wordmark, and yellow, hanging in the arched windows of the park’s historic industrial building.](/media/parc-central/parc-central-14-fabric-banners.jpg \"full 1440x960\")\n\n![Instagram stories cycling through the monthly programme, with zero-waste and water-saving activities and educational workshops.](/media/parc-central/parc-central-15-insta-stories.mp4 \"full 1440x900\")\n\n![Parc Central poster in a bus shelter, with the slogan, a photo, the wordmark and an orange illustrated section.](/media/parc-central/parc-central-16-posters-identity-mockup-2.jpg \"half 613x920\")\n![Instagram posts in the identity’s style, including “Cuidem l’aigua” and “Vine amb el teu gos!”](/media/parc-central/parc-central-17-insta-posts.mp4 \"half 1042x1618\")\n\nThrough this approach, the visual identity not only represents the park aesthetically but also reinforces its role as an inclusive, welcoming, and participatory urban environment, where design supports legibility, accessibility, and a sense of belonging for all visitors.\n\n![Participatory postcards: the front with the vertical wordmark, and three cards filled in by visitors with drawings and notes about what they like to do in the park.](/media/parc-central/parc-central-18-postcards.jpg \"full 2880x1000\")";


var $d0bb5656b4fb8e8d$exports = {};
$d0bb5656b4fb8e8d$exports = "## Origin\nThe project stems from the union of tradition, mythology, and emotion: the creation of Xana preserves family history, passed down from grandmother to mother and from mother to daughter, while adding a touch of modernity that updates its identity without losing its authenticity. \n\n\n## Concept\nInspired by the figure of Echo and the xanas, nymphs tasked with protecting loved ones, Xana is conceived as an ode to romance, inviting us to celebrate first feelings and toast to first words of love. Its identity conveys delicacy, authenticity, and an emotional connection to local tradition and culture.\n\n![Bottle of Xana white wine on a pale background, with a green label of concentric ripples.](/media/xana/xana-02.webp \"full 2000x1251\")\n\n\n![Close-up of the bottle neck with a lilac seal reading XANA 2023.](/media/xana/xana-03.webp \"half 1000x1251\")\n![Close-up of the label with the line “En el murmullo del agua, el eco de las palabras danza”.](/media/xana/xana-04.webp \"half 1000x1251\")\n\nThe label depicts the waves created by water when it hears words of love, becoming an extension of those words—and, therefore, their echo\n\n![Picnic with a bottle of Xana, bread with jam and cheese, and berries.](/media/xana/xana-05.webp \"half 1000x1251\")\n![Someone uncorking a bottle of Xana on a picnic blanket, next to a glass and a strawberry cake.](/media/xana/xana-06.webp \"half 1000x1251\")\n\n![Flat label design: the green ripple artwork on the front and a mint panel with the tagline, product details and barcode.](/media/xana/xana-07.webp \"full 2000x1200\")\n\n![A hand holding a bottle of Xana up against a blue sky.](/media/xana/xana-08.webp \"full 2000x1235\")\n\n";


var $0a0803bed5a2f02e$exports = {};
$0a0803bed5a2f02e$exports = "<p class=\"case-section__eyebrow\">Concept & Art direction</p>\n\n## A visual language in constant motion.\nThe street is the starting point. It is where movement happens without a script: people cross paths, encounters are spontaneous, and nothing stays still for long.\n\nBlink's graphic language borrows that behaviour. Elements overlap instead of sitting neatly side by side. Noisy textures roughen the surfaces. Flashes of light cut through the compositions, and vibrant colours keep them charged. The result is layered and unpredictable — a city in constant flux, and a fitting register for a festival dedicated to motion.\n\n\n\n\n<p class=\"case-section__eyebrow\">Website Experience</p>\n\n## Everything you need to find your way in.\nThe website brings together the information attendees need to discover the festival and plan their experience. From the programme and speaker profiles to ticket options and event locations, the interface provides a central point of access to the festival's key information.\n\nThe speaker section introduces the invited artists and their work, while individual profiles offer a closer look at each conference participant. The ticketing section presents the available passes, prices and purchase links, helping visitors identify the option that suits them. FAQs address practical questions, making essential information easy to find.\n\nThe experience also extends the visual identity into the site's structure. An experimental footer brings together logos, partners and contact information, closing the page with the same graphic expressiveness that defines the festival.\n\n\n<p class=\"case-section__eyebrow\">App Experience</p>\n\n## The whole festival, at one glance.\nDesigned to accompany attendees throughout the event, the mobile app brings the festival programme, live talks and professional networking together in one place.\n\nThe programme allows users to explore the festival schedule, while live streaming makes talks accessible to those unable to attend in person. The app therefore supports different ways of participating in the festival, whether on-site or remotely.\n\nNetworking is built around personal profiles and QR code exchange. Each attendee can share a professional profile containing their name, company, role and location, alongside an optional indicator showing whether they are open to commissions or collaborations. By scanning another attendee's QR code, users can save their profile to a personal contact library and revisit the information later.\n\nTogether, these features make the app both a practical festival companion and a tool for maintaining connections beyond individual talks and encounters.\n\n\n\n<p class=\"case-section__eyebrow\">Interactive Experience</p>\n\n## A shared canvas for collective movement.\nBlink's digital experience extends beyond personal screens through an interactive installation designed for a large horizontal display within the festival venue.\n\nConceived as an opportunity for playful and experimental participation, the installation connects the festival's visual identity with a shared, large-scale digital experience. It creates a space where attendees can engage with the festival collectively, extending its visual language into the physical environment.\n\n\n\n<p class=\"case-section__eyebrow\">Merchandising</p>\n\n## A moving identity, beyond the screen.\nMerchandising takes Blink off the screen and back into the physical world where the concept began. The same overlapping compositions, textures, flashes of light and colour carry over into physical applications, so the festival remains recognisable whether it appears on a phone, in a browser or out on the street.\n\n\n<p class=\"case-section__eyebrow\">Closing</p>\n\n## Every touchpoint answers to the street.\nFrom the first digital encounter to the connections made in person, Blink brings its central idea of movement to every part of the festival experience. Visual identity, digital interfaces and physical applications work together to express a world that never stands still — one that keeps unfolding, moment after moment, in the blink of an eye.\n\n\n![Close-up of the bottle neck with a lilac seal reading XANA 2023.](/media/xana/xana-03.webp \"half 1000x1251\")\n![Close-up of the label with the line “En el murmullo del agua, el eco de las palabras danza”.](/media/xana/xana-04.webp \"half 1000x1251\")\n\nThe label depicts the waves created by water when it hears words of love, becoming an extension of those words—and, therefore, their echo\n\n![Picnic with a bottle of Xana, bread with jam and cheese, and berries.](/media/xana/xana-05.webp \"half 1000x1251\")\n![Someone uncorking a bottle of Xana on a picnic blanket, next to a glass and a strawberry cake.](/media/xana/xana-06.webp \"half 1000x1251\")\n\n![Flat label design: the green ripple artwork on the front and a mint panel with the tagline, product details and barcode.](/media/xana/xana-07.webp \"full 2000x1200\")\n\n![A hand holding a bottle of Xana up against a blue sky.](/media/xana/xana-08.webp \"full 2000x1235\")\n\n";


// ─── Content map ──────────────────────────────────
const $0918ca489adad7b4$var$contentMap = {
    'senda': (0, (/*@__PURE__*/$parcel$interopDefault($a0942e6de8b62304$exports))),
    'parc-central': (0, (/*@__PURE__*/$parcel$interopDefault($679b34a1dc3f6e9c$exports))),
    'xana': (0, (/*@__PURE__*/$parcel$interopDefault($d0bb5656b4fb8e8d$exports))),
    'blink': (0, (/*@__PURE__*/$parcel$interopDefault($0a0803bed5a2f02e$exports)))
};
// ─── Case study renderer ───────────────────────────
//
// Its own Marked instance: the case study BEM classes do not affect the
// global marked that about.js uses (marked.parseInline in the intro).
// Every element gets its .case-section class (case-section.css), so the
// styles do not depend on descendant selectors.
const $0918ca489adad7b4$var$caseMarked = new (0, $25a11d61f10b4ce2$exports.Marked)();
const $0918ca489adad7b4$var$renderer = new $0918ca489adad7b4$var$caseMarked.Renderer();
const $0918ca489adad7b4$var$HEADING_CLASS = {
    2: 'case-section__title',
    3: 'case-section__subtitle',
    4: 'case-section__subheading'
};
$0918ca489adad7b4$var$renderer.heading = function({ tokens: tokens, text: text, depth: depth }) {
    const id = text.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').trim();
    const cls = $0918ca489adad7b4$var$HEADING_CLASS[depth] ? ` class="${$0918ca489adad7b4$var$HEADING_CLASS[depth]}"` : '';
    return `<h${depth}${cls} id="${id}">${this.parser.parseInline(tokens)}</h${depth}>\n`;
};
$0918ca489adad7b4$var$renderer.paragraph = function({ tokens: tokens }) {
    return `<p class="case-section__text">${this.parser.parseInline(tokens)}</p>\n`;
};
$0918ca489adad7b4$var$renderer.list = function(token) {
    const tag = token.ordered ? 'ol' : 'ul';
    const mod = token.ordered ? ' case-section__list--ordered' : '';
    const start = token.ordered && token.start !== 1 ? ` start="${token.start}"` : '';
    const items = token.items.map((item)=>this.listitem(item)).join('');
    return `<${tag} class="case-section__list${mod}"${start}>\n${items}</${tag}>\n`;
};
$0918ca489adad7b4$var$renderer.listitem = function(item) {
    return `<li class="case-section__item">${this.parser.parse(item.tokens, !!item.loose)}</li>\n`;
};
$0918ca489adad7b4$var$renderer.strong = function({ tokens: tokens }) {
    return `<strong class="case-section__strong">${this.parser.parseInline(tokens)}</strong>`;
};
// The image title in Markdown carries the layout and the intrinsic size
// of the file: ![alt](path "full 1440x960"). With width and height the
// browser reserves the space before the file loads, so the text does not
// jump while scrolling. Videos can add
// poster=/media/<project>/<video>-poster.webp: ![alt](path "full 1440x900 poster=…").
function $0918ca489adad7b4$var$parseImageTitle(title) {
    var _parts_find;
    const parts = (title !== null && title !== void 0 ? title : '').trim().split(/\s+/).filter(Boolean);
    const size = parts.find((p)=>/^\d+x\d+$/.test(p));
    const poster = (_parts_find = parts.find((p)=>p.startsWith('poster='))) === null || _parts_find === void 0 ? void 0 : _parts_find.slice('poster='.length);
    var _parts_find1;
    const mod = (_parts_find1 = parts.find((p)=>p !== size && !p.startsWith('poster='))) !== null && _parts_find1 !== void 0 ? _parts_find1 : 'default';
    const [width, height] = size ? size.split('x') : [];
    return {
        mod: mod,
        poster: poster,
        dims: size ? ` width="${width}" height="${height}"` : ''
    };
}
// sizes of the case study figures: how wide each layout shows them, so the
// browser picks the right width from srcset. Derived from the case grid
// (case.css): the content takes 7 of 12 columns from 1025px (880px at most),
// and below that the full width minus the side padding. Approximate on
// purpose: the browser rounds up to the next available width.
const $0918ca489adad7b4$var$FIGURE_SIZES = {
    full: '(min-width: 1568px) 880px, (min-width: 1025px) calc(58.33vw - 35px), calc(100vw - 96px)',
    half: '(min-width: 1568px) 430px, (min-width: 1025px) calc(29.17vw - 28px), (min-width: 769px) calc(50vw - 58px), calc(100vw - 96px)'
};
const $0918ca489adad7b4$var$sizesFor = (mod)=>[
        'half',
        'duo',
        'portrait'
    ].includes(mod) ? $0918ca489adad7b4$var$FIGURE_SIZES.half : $0918ca489adad7b4$var$FIGURE_SIZES.full;
$0918ca489adad7b4$var$renderer.image = ({ href: href, title: title, text: text })=>{
    const { mod: mod, dims: dims, poster: poster } = $0918ca489adad7b4$var$parseImageTitle(title);
    // Looping video with no playback bar. Nothing downloads, not even the
    // poster (it goes in data-poster), until initLoopVideos() (case.js) brings
    // it near the viewport. The #t=0.001 fragment makes Safari/iOS paint the
    // first frame when only the metadata loads (reduced motion).
    if (/\.(mp4|webm)$/i.test(href)) {
        const type = href.toLowerCase().endsWith('.webm') ? 'video/webm' : 'video/mp4';
        return `
      <figure class="case-figure case-figure--${mod} case-figure--video">
        <div class="case-figure__video">
          <video class="case-figure__player" muted loop playsinline preload="none"${dims}${poster ? ` data-poster="${poster}"` : ''} aria-label="${text}">
            <source src="${href}#t=0.001" type="${type}">
          </video>
        </div>
      </figure>
    `;
    }
    // Images generated by the media pipeline get every width in srcset; the
    // rest (SVG, manual files) keep a single src.
    const responsive = $0918ca489adad7b4$export$cc734a7c9455c1b3(href);
    const size = dims || (responsive ? ` width="${responsive.width}" height="${responsive.height}"` : '');
    const srcset = responsive ? `
          srcset="${responsive.srcset}"
          sizes="${$0918ca489adad7b4$var$sizesFor(mod)}"` : '';
    return `
    <figure class="case-figure case-figure--${mod}">
      <picture class="case-figure__frame">
        <img
          class="case-figure__image"
          src="${href}"${srcset}
          alt="${text}"${size}
          loading="lazy"
          decoding="async">
      </picture>
    </figure>
  `;
};
$0918ca489adad7b4$var$renderer.blockquote = ({ text: text })=>`
  <blockquote class="case-quote">${text}</blockquote>
`;
$0918ca489adad7b4$var$caseMarked.use({
    renderer: $0918ca489adad7b4$var$renderer
});
// ─── Media groups (.case-section__media) ───────────
// Marked wraps images in <p>, and as a <figure> cannot go inside a
// paragraph, the browser closes the <p> before the figure and leaves an
// empty <p></p> behind. Here:
// 1. A paragraph that mixes text and images is split into a text
//    paragraph and an image paragraph, in the same order.
// 2. Consecutive paragraphs with only images or videos (even if a blank
//    line separates them) join in one container, which sets the space
//    between figures with gap (case-section.css).
// Figures still come from renderer.image.
const $0918ca489adad7b4$var$isBlank = (t)=>t.type === 'br' || t.type === 'text' && !t.text.trim();
function $0918ca489adad7b4$var$isMediaParagraph(token) {
    if (token.type !== 'paragraph') return false;
    var _token_tokens;
    const inline = (_token_tokens = token.tokens) !== null && _token_tokens !== void 0 ? _token_tokens : [];
    return inline.some((t)=>t.type === 'image') && inline.every((t)=>t.type === 'image' || $0918ca489adad7b4$var$isBlank(t));
}
// Splits a mixed paragraph into runs of text and runs of images
function $0918ca489adad7b4$var$splitMixedParagraph(token) {
    var _token_tokens;
    const inline = (_token_tokens = token.tokens) !== null && _token_tokens !== void 0 ? _token_tokens : [];
    if (token.type !== 'paragraph' || $0918ca489adad7b4$var$isMediaParagraph(token) || !inline.some((t)=>t.type === 'image')) return [
        token
    ];
    const runs = [];
    for (const t of inline){
        const kind = t.type === 'image' ? 'media' : 'text';
        const last = runs[runs.length - 1];
        if (last && (last.kind === kind || $0918ca489adad7b4$var$isBlank(t) && last.kind === 'media')) last.tokens.push(t);
        else runs.push({
            kind: kind,
            tokens: [
                t
            ]
        });
    }
    return runs.filter((r)=>r.tokens.some((t)=>!$0918ca489adad7b4$var$isBlank(t))).map((r)=>{
        const raw = r.tokens.map((t)=>t.raw).join('');
        return {
            type: 'paragraph',
            raw: raw,
            text: raw,
            tokens: r.tokens
        };
    });
}
$0918ca489adad7b4$var$caseMarked.use({
    extensions: [
        {
            name: 'caseMedia',
            renderer ({ paragraphs: paragraphs }) {
                const figures = paragraphs.map((p)=>this.parser.parseInline(p.tokens)).join('');
                return `<div class="case-section__media">${figures}</div>\n`;
            }
        }
    ],
    hooks: {
        processAllTokens (tokens) {
            const flat = tokens.flatMap($0918ca489adad7b4$var$splitMixedParagraph);
            const result = [];
            for(let i = 0; i < flat.length; i++){
                if (!$0918ca489adad7b4$var$isMediaParagraph(flat[i])) {
                    result.push(flat[i]);
                    continue;
                }
                // Joins the following media paragraphs, skipping blank lines
                const paragraphs = [
                    flat[i]
                ];
                let next = i + 1;
                while(next < flat.length){
                    if (flat[next].type === 'space') {
                        next++;
                        continue;
                    }
                    if (!$0918ca489adad7b4$var$isMediaParagraph(flat[next])) break;
                    paragraphs.push(flat[next]);
                    i = next++;
                }
                result.push({
                    type: 'caseMedia',
                    raw: paragraphs.map((p)=>p.raw).join(''),
                    paragraphs: paragraphs
                });
            }
            return result;
        }
    }
});
function $0918ca489adad7b4$export$cc734a7c9455c1b3(src) {
    const entry = (0, (/*@__PURE__*/$parcel$interopDefault($b6861875f722fafb$exports)))[src];
    if (!entry) return null;
    const srcset = entry.widths.map((w)=>`${w === entry.width ? src : src.replace(/\.webp$/i, `-${w}w.webp`)} ${w}w`).join(', ');
    return {
        srcset: srcset,
        width: entry.width,
        height: entry.height
    };
}
function $0918ca489adad7b4$export$5696459faf0975d(src, sizes) {
    const r = $0918ca489adad7b4$export$cc734a7c9455c1b3(src);
    if (!r) return `src="${src}"`;
    return `src="${src}" srcset="${r.srcset}" sizes="${sizes}" width="${r.width}" height="${r.height}"`;
}
function $0918ca489adad7b4$export$2299ea7b72945fcc(src, sizes) {
    const r = $0918ca489adad7b4$export$cc734a7c9455c1b3(src);
    if (!r) return `srcset="${src}"`;
    return `srcset="${r.srcset}" sizes="${sizes}" width="${r.width}" height="${r.height}"`;
}
async function $0918ca489adad7b4$export$f0d2ca471cdb99b0() {
    return 0, (/*@__PURE__*/$parcel$interopDefault($7387a28c2ed353d6$exports));
}
async function $0918ca489adad7b4$export$c30f175aba571500(slug) {
    const md = $0918ca489adad7b4$var$contentMap[slug];
    if (!md) throw new Error(`Content not found: ${slug}`);
    return $0918ca489adad7b4$var$caseMarked.parse(md);
}
function $0918ca489adad7b4$export$bca74923a5f13e55(projects) {
    const all = projects.flatMap((p)=>p.tags);
    return [
        ...new Set(all)
    ].sort();
}
function $0918ca489adad7b4$export$c8b627156f9fcdf5(slug) {
    return slug in $0918ca489adad7b4$var$contentMap;
}
function $0918ca489adad7b4$export$e8c55a0bcbd53ecb(project) {
    var _project_thumbnail;
    return (_project_thumbnail = project.thumbnail) !== null && _project_thumbnail !== void 0 ? _project_thumbnail : project.hero;
}
const $0918ca489adad7b4$export$bbc4a3571a11299 = '(max-width: 767.98px) and (max-aspect-ratio: 3/4)';




// sizes of the featured cards: how wide each one is shown, so the browser
// picks the right width from srcset. Derived from the 12-column grid
// (featured-card.css) inside .container (1520px at most): the lead card
// takes the whole row; from 1025px the others alternate 7 and 5 columns
// (positions 4n+2 and 4n+5 take 7); from 769px they take 6; below that,
// the whole row. Approximate on purpose: the browser rounds up.
const $c989ba879ed802fa$var$CARD_SIZES = {
    lead: '(min-width: 1568px) 1520px, calc(100vw - 48px)',
    seven: '(min-width: 1568px) 880px, (min-width: 1025px) calc(58.33vw - 35px), (min-width: 769px) calc(50vw - 32px), calc(100vw - 48px)',
    five: '(min-width: 1568px) 624px, (min-width: 1025px) calc(41.67vw - 30px), (min-width: 769px) calc(50vw - 32px), calc(100vw - 48px)'
};
function $c989ba879ed802fa$var$cardSizes(i) {
    if (i === 0) return $c989ba879ed802fa$var$CARD_SIZES.lead;
    const n = i + 1; // nth-child position, as in the CSS
    return n % 4 === 2 || n % 4 === 1 ? $c989ba879ed802fa$var$CARD_SIZES.seven : $c989ba879ed802fa$var$CARD_SIZES.five;
}
/** Renders the project grid from the current state */ function $c989ba879ed802fa$var$renderProjects(state) {
    const list = document.querySelector('#featured-projects');
    if (!list) return;
    const visible = state.projects;
    list.setAttribute('aria-busy', state.loading ? 'true' : 'false');
    if (state.loading) {
        list.innerHTML = `<li class="featured-grid__status">Loading projects\u{2026}</li>`;
        return;
    }
    if (state.error) {
        list.innerHTML = `<li class="featured-grid__status" role="alert">Projects couldn\u{2019}t be loaded.</li>`;
        return;
    }
    if (visible.length === 0) {
        list.innerHTML = `<li class="featured-grid__status">No projects yet.</li>`;
        return;
    }
    list.innerHTML = visible.map((project, i)=>{
        const isFeatured = i === 0;
        const available = (0, $0918ca489adad7b4$export$c8b627156f9fcdf5)(project.slug);
        const thumb = (0, $0918ca489adad7b4$export$e8c55a0bcbd53ecb)(project);
        const chipText = !available ? 'Coming soon!' : isFeatured ? 'See case study' : 'See work';
        // No case study: a card without a link; the "Coming soon!" chip is
        // announced because it is the only hint of the project's status
        const wrapperStart = available ? `<a class="featured-card__link" href="/project/${project.slug}/">` : '<div class="featured-card__inner">';
        const wrapperEnd = available ? '</a>' : '</div>';
        var _project_claim;
        return `
        <li class="featured-card${isFeatured ? ' featured-card--lead' : ''}${available ? '' : ' featured-card--coming-soon'}">
        ${wrapperStart}
          <figure class="featured-card__figure">
            <picture>${isFeatured && project.heroMobile ? `
              <source media="${0, $0918ca489adad7b4$export$bbc4a3571a11299}" ${(0, $0918ca489adad7b4$export$2299ea7b72945fcc)(project.heroMobile, $c989ba879ed802fa$var$CARD_SIZES.lead)}>` : ''}
              <img
                class="featured-card__image"
                ${(0, $0918ca489adad7b4$export$5696459faf0975d)(thumb, $c989ba879ed802fa$var$cardSizes(i))}
                ${i === 0 ? 'fetchpriority="high"' : 'loading="lazy"'}
                decoding="async"
                alt="">
            </picture>
            <div class="chip${available ? '' : ' chip--coming-soon'}"${available ? ' aria-hidden="true"' : ''}>
              <span class="chip__label">${chipText}</span>
            </div>
          </figure>
          <div class="featured-card__info">
            <h2 class="featured-card__title">${project.title}</h2>
            <p class="featured-card__claim">${(_project_claim = project.claim) !== null && _project_claim !== void 0 ? _project_claim : project.summary}</p>
          </div>
        ${wrapperEnd}
      </li>
    `;
    }).join('');
}
/** Bootstrap */ async function $c989ba879ed802fa$var$init() {
    (0, $8026bd73ef96f544$export$2e2bcd8739ae039).subscribe($c989ba879ed802fa$var$renderProjects);
    (0, $8026bd73ef96f544$export$2e2bcd8739ae039).setState({
        loading: true
    });
    try {
        const projects = await (0, $0918ca489adad7b4$export$f0d2ca471cdb99b0)();
        const featured = projects.filter((p)=>p.featured === true);
        (0, $8026bd73ef96f544$export$2e2bcd8739ae039).setState({
            projects: featured,
            loading: false
        });
    } catch (err) {
        console.error(err);
        (0, $8026bd73ef96f544$export$2e2bcd8739ae039).setState({
            loading: false,
            error: err.message
        });
    }
}
function $c989ba879ed802fa$export$8a39893ac75b3cff() {
    $c989ba879ed802fa$var$init();
}


/**
 * case.js — Case study page (URL /project/<slug>/)
 *
 * Reads the slug from the URL, loads the projects JSON and the case
 * study Markdown, and fills the DOM.
 */ 
/**
 * case-lightbox.js — Lightbox for the case study figures
 *
 * Creates one <dialog> that every figure (.case-figure) of the page
 * reuses. Each figure gets an "enlarge" button that opens its image or
 * video full screen. The button icons are painted by CSS (mask-image),
 * so no SVG is injected here.
 */ function $c396b5e8ce059116$export$d1d72e9efa927b5e(root = document) {
    const figures = root.querySelectorAll('.case-figure');
    if (!figures.length) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    // The <dialog> is created once and every figure reuses it.
    let dialog = document.getElementById('case-lightbox');
    if (!dialog) {
        dialog = document.createElement('dialog');
        dialog.id = 'case-lightbox';
        dialog.className = 'case-lightbox';
        dialog.innerHTML = `
      <button type="button" class="icon-button case-lightbox__close" aria-label="Close enlarged view"></button>
      <img class="case-lightbox__image" src="" alt="" hidden>
      <video class="case-lightbox__video" controls loop muted playsinline hidden></video>
    `;
        document.body.appendChild(dialog);
    }
    const dialogImg = dialog.querySelector('.case-lightbox__image');
    const dialogVideo = dialog.querySelector('.case-lightbox__video');
    const closeButton = dialog.querySelector('.case-lightbox__close');
    let lastFocused = null;
    let sourceVideo = null; // page video that opened the lightbox
    let resumeSource = false; // whether it was playing when opened
    function openImage(img, triggerButton) {
        lastFocused = triggerButton;
        dialogVideo.hidden = true;
        dialogImg.hidden = false;
        // The enlarged view picks its own width: srcset with the size of the
        // dialog (90vw), not the smaller one the page figure is using. Images
        // without variants have an empty srcset and use src (the full file).
        dialogImg.sizes = '90vw';
        dialogImg.srcset = img.srcset;
        dialogImg.src = img.src;
        dialogImg.alt = img.alt;
        dialog.setAttribute('aria-label', 'Enlarged image');
        dialog.showModal();
    }
    function openVideo(video, triggerButton) {
        var _video_querySelector;
        lastFocused = triggerButton;
        sourceVideo = video;
        resumeSource = !video.paused;
        video.pause(); // avoids two playbacks at once
        dialogImg.hidden = true;
        dialogVideo.hidden = false;
        // With preload="none" the video may not have loaded yet: use the <source>
        dialogVideo.src = video.currentSrc || ((_video_querySelector = video.querySelector('source')) === null || _video_querySelector === void 0 ? void 0 : _video_querySelector.src) || '';
        var _video_getAttribute;
        dialogVideo.setAttribute('aria-label', (_video_getAttribute = video.getAttribute('aria-label')) !== null && _video_getAttribute !== void 0 ? _video_getAttribute : '');
        dialog.setAttribute('aria-label', 'Enlarged video');
        dialog.showModal();
        if (!reduceMotion.matches) dialogVideo.play().catch(()=>{});
    }
    function closeLightbox() {
        dialog.close();
    }
    closeButton.addEventListener('click', closeLightbox);
    // Closes on a click on the backdrop (outside the content).
    dialog.addEventListener('click', (event)=>{
        if (event.target === dialog) closeLightbox();
    });
    // <dialog> already closes with Escape natively; here we free the
    // resources, resume the original video if it was playing and return
    // focus to the button that opened the lightbox.
    dialog.addEventListener('close', ()=>{
        dialogImg.removeAttribute('srcset');
        dialogImg.src = '';
        dialogVideo.pause();
        dialogVideo.removeAttribute('src');
        dialogVideo.load();
        if (sourceVideo && resumeSource) sourceVideo.play().catch(()=>{});
        sourceVideo = null;
        lastFocused === null || lastFocused === void 0 ? void 0 : lastFocused.focus();
    });
    figures.forEach((figure)=>{
        if (figure.querySelector('.case-figure__expand')) return;
        const video = figure.querySelector('video');
        const img = figure.querySelector('img');
        if (!video && !img) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'icon-button icon-button--translucent case-figure__expand';
        button.setAttribute('aria-label', video ? 'Enlarge video' : 'Enlarge image');
        if (video) {
            button.addEventListener('click', ()=>openVideo(video, button));
            // Inside the video wrapper, to anchor it to the video
            figure.querySelector('.case-figure__video').appendChild(button);
        } else {
            button.addEventListener('click', ()=>openImage(img, button));
            figure.appendChild(button);
        }
    });
}


// ─── DOM utilities ─────────────────────────────────
function $3f6a718d6e2706d8$var$$(id) {
    return document.getElementById(id);
}
function $3f6a718d6e2706d8$var$setText(id, value) {
    const el = $3f6a718d6e2706d8$var$$(id);
    if (el && value) el.textContent = value;
}
function $3f6a718d6e2706d8$var$show(id) {
    const el = $3f6a718d6e2706d8$var$$(id);
    if (el) el.hidden = false;
}
function $3f6a718d6e2706d8$var$hide(id) {
    const el = $3f6a718d6e2706d8$var$$(id);
    if (el) el.hidden = true;
}
function $3f6a718d6e2706d8$var$slugify(text) {
    return text.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').trim();
}
// ─── Slug from the URL ─────────────────────────────
function $3f6a718d6e2706d8$var$getSlugFromURL() {
    const parts = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
    var _parts_;
    return (_parts_ = parts[1]) !== null && _parts_ !== void 0 ? _parts_ : null;
}
// ─── Eyebrow before each h2 ─────────────────────────
//
// In the Markdown, the eyebrow is a <p class="case-section__eyebrow">
// written right before an h2, e.g. "Research" before "## We assumed the
// problem...". It is not <strong>: the eyebrow is a category label, not
// text emphasis, so only the class is checked here, not the structure.
function $3f6a718d6e2706d8$var$getEyebrowFor(h2) {
    const prev = h2.previousElementSibling;
    return (prev === null || prev === void 0 ? void 0 : prev.classList.contains('case-section__eyebrow')) ? prev : null;
}
// ─── In-page index ─────────────────────────────────
function $3f6a718d6e2706d8$var$renderIndex() {
    const indexNav = document.querySelector('.section-index');
    if (!indexNav) return;
    // Overview lives outside the case study (in .case__main, before the
    // article), but it is the first entry of the index. querySelectorAll
    // returns elements in document order, so it comes first.
    const sections = Array.from(document.querySelectorAll('#overview, #case-body > .case-section'));
    if (!sections.length) return;
    // The index label comes from each section's eyebrow; if a section has
    // no eyebrow, it falls back to the text of the h2.
    const items = sections.map((section)=>{
        var _this;
        const eyebrow = section.querySelector(':scope > .case-section__eyebrow');
        const heading = section.querySelector(':scope > .case-section__title, :scope > h2');
        var _textContent_trim;
        return {
            id: section.id,
            label: (_textContent_trim = (_this = eyebrow !== null && eyebrow !== void 0 ? eyebrow : heading) === null || _this === void 0 ? void 0 : _this.textContent.trim()) !== null && _textContent_trim !== void 0 ? _textContent_trim : ''
        };
    });
    indexNav.innerHTML = `
    <ul class="section-index__list">
      ${items.map((s)=>`
        <li class="section-index__item">
          <a href="#${s.id}" class="section-index__link">${s.label}</a>
        </li>
      `).join('')}
    </ul>
  `;
    // The links are native anchors: the browser moves focus to the section,
    // updates the URL and respects prefers-reduced-motion. The offset of the
    // fixed header comes from scroll-margin-top (case-section.css).
    // Marks the active link while scrolling (measured by the position of
    // the h2, as the eyebrow sits right above it).
    const links = indexNav.querySelectorAll('.section-index__link');
    const headings = sections.map((section)=>section.querySelector(':scope > .case-section__title, :scope > h2')).filter(Boolean);
    function updateActiveLink() {
        const headerEl = document.querySelector('.site-nav');
        const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 64;
        // FIX: the reference line used to sit right below the header (+32px),
        // so a section did not become "active" until its heading almost
        // touched the header. With the next section already well in view, the
        // nav still pointed at the previous one. The line moves to ~35% of the
        // window height: the change happens as soon as the new section is the
        // visible one, not when the previous one has almost gone.
        const triggerLine = window.scrollY + headerHeight + window.innerHeight * 0.35;
        let current = null;
        headings.forEach((h)=>{
            var _h_closest;
            const top = h.getBoundingClientRect().top + window.scrollY;
            var _h_closest_id;
            if (top <= triggerLine) current = (_h_closest_id = (_h_closest = h.closest('section')) === null || _h_closest === void 0 ? void 0 : _h_closest.id) !== null && _h_closest_id !== void 0 ? _h_closest_id : h.id;
        });
        links.forEach((link)=>{
            if (link.getAttribute('href') === `#${current}`) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
        });
    }
    window.addEventListener('scroll', updateActiveLink, {
        passive: true
    });
    updateActiveLink();
}
// ─── Insights carousel ─────────────────────────────
function $3f6a718d6e2706d8$var$initInsightsCarousel(root = document) {
    const track = root.querySelector('.insights__track');
    const prevButton = root.querySelector('[data-scroll="prev"]');
    const nextButton = root.querySelector('[data-scroll="next"]');
    if (!track || !prevButton || !nextButton) return;
    const getStep = ()=>{
        const card = track.querySelector('.insight-card');
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    };
    // 1px of tolerance at both ends: some browsers (Firefox) leave scrollLeft
    // at a fraction of a pixel instead of an exact 0 or end value.
    const updateArrowState = ()=>{
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = track;
        prevButton.disabled = scrollLeft <= 1;
        nextButton.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    };
    prevButton.addEventListener('click', ()=>{
        track.scrollBy({
            left: -getStep(),
            behavior: 'smooth'
        });
    });
    nextButton.addEventListener('click', ()=>{
        track.scrollBy({
            left: getStep(),
            behavior: 'smooth'
        });
    });
    track.addEventListener('scroll', updateArrowState, {
        passive: true
    });
    updateArrowState();
    // The carousel starts while the case study is still hidden (zero width),
    // so the arrows are measured again when the track gets its size: when the
    // page is shown and on every resize.
    if ('ResizeObserver' in window) new ResizeObserver(updateArrowState).observe(track);
}
// ── Related work ──────────────────────────────────────────────
const $3f6a718d6e2706d8$var$RELATED_LIMIT = 3;
// sizes of the related work images: on desktop with a pointer, three cards
// in columns 5 to 12 of the full-width grid; otherwise a carousel of cards
// at 75% of the width, 320px at most (related-work.css). Approximate.
const $3f6a718d6e2706d8$var$RELATED_SIZES = '(min-width: 1024px) and (hover: hover) calc(22.22vw - 23px), (min-width: 475px) 320px, calc(75vw - 36px)';
function $3f6a718d6e2706d8$var$getRelatedProjects(current, projects, limit = $3f6a718d6e2706d8$var$RELATED_LIMIT) {
    var _current_tags;
    const currentTags = new Set((_current_tags = current.tags) !== null && _current_tags !== void 0 ? _current_tags : []);
    return projects.filter((p)=>p.slug !== current.slug && (0, $0918ca489adad7b4$export$c8b627156f9fcdf5)(p.slug)).map((p)=>{
        var _p_tags;
        return {
            project: p,
            shared: ((_p_tags = p.tags) !== null && _p_tags !== void 0 ? _p_tags : []).filter((tag)=>currentTags.has(tag)).length,
            year: parseInt(p.year, 10) || 0,
            tiebreak: Math.random()
        };
    }).sort((a, b)=>b.shared - a.shared || b.year - a.year || a.tiebreak - b.tiebreak).slice(0, limit).map(({ project: project })=>project);
}
function $3f6a718d6e2706d8$var$renderRelatedWork(current, projects) {
    const section = document.querySelector('.related-work');
    if (!section) return;
    const related = $3f6a718d6e2706d8$var$getRelatedProjects(current, projects);
    if (related.length === 0) return;
    var _related__claim;
    section.innerHTML = `
    <div class="related-work__aside">
      <h2 class="related-work__label" id="related-work-title">Related work</h2>
      <div class="related-work__info" aria-hidden="true">
        <p class="related-work__title">${related[0].title}</p>
        <p class="related-work__claim">${(_related__claim = related[0].claim) !== null && _related__claim !== void 0 ? _related__claim : ''}</p>
      </div>
    </div>
    <ul class="related-work__list" role="list">
      ${related.map((p, i)=>{
        var _p_claim;
        return `
        <li class="related-work__item">
          <a class="related-work__link" href="/project/${p.slug}/" data-index="${i}">
            <figure class="related-work__figure">
              <img class="related-work__image" ${(0, $0918ca489adad7b4$export$5696459faf0975d)((0, $0918ca489adad7b4$export$e8c55a0bcbd53ecb)(p), $3f6a718d6e2706d8$var$RELATED_SIZES)} alt="" loading="lazy" decoding="async">
            </figure>
            <span class="related-work__caption">
              <span class="related-work__caption-title">${p.title}</span>
              <span class="related-work__caption-claim">${(_p_claim = p.claim) !== null && _p_claim !== void 0 ? _p_claim : ''}</span>
            </span>
          </a>
        </li>
      `;
    }).join('')}
    </ul>
  `;
    const title = section.querySelector('.related-work__title');
    const claim = section.querySelector('.related-work__claim');
    const showProject = (index)=>{
        const p = related[index];
        title.textContent = p.title;
        var _p_claim;
        claim.textContent = (_p_claim = p.claim) !== null && _p_claim !== void 0 ? _p_claim : '';
    };
    section.querySelectorAll('.related-work__link').forEach((link)=>{
        const index = Number(link.dataset.index);
        link.addEventListener('pointerenter', ()=>showProject(index));
        link.addEventListener('focus', ()=>showProject(index));
    });
    section.hidden = false;
}
// ─── Looping videos ────────────────────────────────
function $3f6a718d6e2706d8$var$initLoopVideos(root = document) {
    const videos = root.querySelectorAll('.case-figure__player');
    if (!videos.length) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    // The poster (data-poster) is set on approach, like the video, so they do
    // not all download on arrival. Until there is a poster or a frame, the
    // background of .case-figure__video shows, with its size reserved.
    const showPoster = (video)=>{
        if (video.dataset.poster && !video.getAttribute('poster')) video.poster = video.dataset.poster;
    };
    // Loads the video the first time it nears the screen. With reduced
    // motion it only requests the metadata: the browser shows the first frame
    // as a still image and it plays on demand only. With a poster and reduced
    // motion, the poster is enough: the video waits for the button.
    const approach = (video)=>{
        showPoster(video);
        if (!(reduceMotion.matches && video.dataset.poster)) load(video);
    };
    const load = (video)=>{
        if (video.dataset.loaded) return;
        video.dataset.loaded = 'true';
        video.preload = reduceMotion.matches ? 'metadata' : 'auto';
        video.load();
    };
    const autoplay = (video)=>{
        if (reduceMotion.matches || video.dataset.userPaused === 'true') return;
        video.play().catch(()=>{});
    };
    // Two observers: one starts the download early (300px before it enters)
    // and the other plays only while the video is visible and pauses on exit.
    const supportsIO = 'IntersectionObserver' in window;
    const loadObserver = supportsIO && new IntersectionObserver((entries)=>{
        entries.forEach(({ target: target, isIntersecting: isIntersecting })=>{
            if (isIntersecting) {
                approach(target);
                loadObserver.unobserve(target);
            }
        });
    }, {
        rootMargin: '300px 0px'
    });
    const playObserver = supportsIO && new IntersectionObserver((entries)=>{
        entries.forEach(({ target: target, isIntersecting: isIntersecting })=>{
            if (isIntersecting) autoplay(target);
            else if (!target.paused) target.pause();
        });
    });
    videos.forEach((video)=>{
        const wrapper = video.parentElement;
        if (wrapper.querySelector('.case-figure__toggle')) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'icon-button icon-button--translucent case-figure__toggle';
        const sync = ()=>{
            const paused = video.paused;
            button.dataset.state = paused ? 'paused' : 'playing';
            button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        };
        // The button rules: if the user pauses, the video does not resume by itself
        button.addEventListener('click', ()=>{
            if (video.paused) {
                video.dataset.userPaused = 'false';
                showPoster(video);
                load(video);
                video.play().catch(()=>{});
            } else {
                video.dataset.userPaused = 'true';
                video.pause();
            }
        });
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        wrapper.appendChild(button);
        sync();
        if (supportsIO) {
            loadObserver.observe(video);
            playObserver.observe(video);
        } else {
            // Browsers without IntersectionObserver: previous behaviour
            approach(video);
            autoplay(video);
        }
    });
}
// ─── Back to top (see back-to-top.css) ─────────────
// Up to 1024px the index sits above the content: the button shows once the
// index has left the top (before that it would cover the first label).
// From 1025px the index stays visible in the sticky sidebar: the button
// shows after scrolling one viewport. In both cases it hides on reaching
// related work and the footer, which has its own "Up" link.
// It is computed on scroll (once per frame) and not with an
// IntersectionObserver: a scroll jump (an index link, a reload mid-page) can
// pass the index without crossing the viewport, and the observer would not
// notice.
let $3f6a718d6e2706d8$var$stopBackToTop = ()=>{};
const $3f6a718d6e2706d8$var$desktop = window.matchMedia('(min-width: 1025px)'); // the sidebar stacks at max-width: 1024px
function $3f6a718d6e2706d8$var$initBackToTop() {
    $3f6a718d6e2706d8$var$stopBackToTop();
    const button = document.querySelector('.back-to-top');
    const index = document.querySelector('.section-index');
    if (!button || !index) return;
    let frame = 0;
    const update = ()=>{
        frame = 0;
        if (!button.isConnected) return $3f6a718d6e2706d8$var$stopBackToTop(); // left the page (SPA)
        const scrolledPast = $3f6a718d6e2706d8$var$desktop.matches ? window.scrollY > window.innerHeight : index.getBoundingClientRect().bottom < 0;
        const atEnd = [
            ...document.querySelectorAll('.related-work:not([hidden]), site-footer')
        ].some((el)=>el.getBoundingClientRect().top < window.innerHeight);
        button.dataset.visible = String(scrolledPast && !atEnd);
    };
    const schedule = ()=>{
        if (!frame) frame = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', schedule, {
        passive: true
    });
    window.addEventListener('resize', schedule);
    update();
    $3f6a718d6e2706d8$var$stopBackToTop = ()=>{
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        cancelAnimationFrame(frame);
    };
}
// ─── Rendering ─────────────────────────────────────
async function $3f6a718d6e2706d8$var$renderCase(project, allProjects) {
    var _document_querySelector, _document_querySelector1, _document_querySelector2;
    // Document metadata
    document.title = `${project.title} \u{2014} Laura Caballero Garc\xeda`;
    var _project_summary;
    (_document_querySelector = document.querySelector('meta[name="description"]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.setAttribute('content', (_project_summary = project.summary) !== null && _project_summary !== void 0 ? _project_summary : '');
    (_document_querySelector1 = document.querySelector('meta[property="og:title"]')) === null || _document_querySelector1 === void 0 ? void 0 : _document_querySelector1.setAttribute('content', project.title);
    var _project_summary1;
    (_document_querySelector2 = document.querySelector('meta[property="og:description"]')) === null || _document_querySelector2 === void 0 ? void 0 : _document_querySelector2.setAttribute('content', (_project_summary1 = project.summary) !== null && _project_summary1 !== void 0 ? _project_summary1 : '');
    // Hero. If the project declares heroMobile (vertical crop), <picture>
    // serves it on portrait phones (HERO_MOBILE_MEDIA); otherwise every screen
    // uses the hero. Both offer every width (srcset) at the full viewport width.
    const hero = document.querySelector('.case__hero');
    if (hero && project.hero) {
        const picture = document.createElement('picture');
        picture.className = 'case__hero-picture';
        if (project.heroMobile) {
            var _srcsetFor;
            const source = document.createElement('source');
            source.media = (0, $0918ca489adad7b4$export$bbc4a3571a11299);
            var _srcsetFor_srcset;
            source.srcset = (_srcsetFor_srcset = (_srcsetFor = (0, $0918ca489adad7b4$export$cc734a7c9455c1b3)(project.heroMobile)) === null || _srcsetFor === void 0 ? void 0 : _srcsetFor.srcset) !== null && _srcsetFor_srcset !== void 0 ? _srcsetFor_srcset : project.heroMobile;
            source.sizes = '100vw';
            picture.appendChild(source);
        }
        const img = document.createElement('img');
        const heroVariants = (0, $0918ca489adad7b4$export$cc734a7c9455c1b3)(project.hero);
        if (heroVariants) {
            img.sizes = '100vw';
            img.srcset = heroVariants.srcset;
            img.width = heroVariants.width;
            img.height = heroVariants.height;
        }
        img.src = project.hero;
        img.alt = '';
        img.loading = 'eager';
        img.fetchPriority = 'high';
        img.decoding = 'async';
        img.classList.add('case__hero-image');
        picture.appendChild(img);
        hero.appendChild(picture);
    }
    // Sidebar: title, client, tags
    $3f6a718d6e2706d8$var$setText('case-title', project.title);
    var _project_client;
    $3f6a718d6e2706d8$var$setText('case-client', (_project_client = project.client) !== null && _project_client !== void 0 ? _project_client : '');
    const tagsEl = $3f6a718d6e2706d8$var$$('case-tags');
    if (tagsEl) tagsEl.innerHTML = project.tags.map((t)=>`<span class="case-header__tag">${t}</span>`).join('');
    var _project_summary2;
    // Summary
    $3f6a718d6e2706d8$var$setText('case-summary', (_project_summary2 = project.summary) !== null && _project_summary2 !== void 0 ? _project_summary2 : '');
    var _project_timeline;
    // Metadata
    $3f6a718d6e2706d8$var$setText('case-timeline', (_project_timeline = project.timeline) !== null && _project_timeline !== void 0 ? _project_timeline : '');
    if (project.roles) {
        const rolesEl = $3f6a718d6e2706d8$var$$('case-role');
        if (rolesEl) rolesEl.innerHTML = project.roles.map((r)=>`<li>${r}</li>`).join('');
    }
    if (project.tools) {
        const toolsEl = $3f6a718d6e2706d8$var$$('case-tools');
        if (toolsEl) toolsEl.innerHTML = project.tools.map((t)=>`<li>${t}</li>`).join('');
    }
    if (project.team) {
        const teamEl = $3f6a718d6e2706d8$var$$('case-team');
        if (teamEl) teamEl.innerHTML = project.team.map((m)=>`<li>${m}</li>`).join('');
    }
    // Case study content (Markdown)
    const body = $3f6a718d6e2706d8$var$$('case-body');
    if (body) try {
        const html = await (0, $0918ca489adad7b4$export$c30f175aba571500)(project.slug);
        body.innerHTML = html;
        $3f6a718d6e2706d8$var$initInsightsCarousel(body);
        (0, $c396b5e8ce059116$export$d1d72e9efa927b5e)(body);
        $3f6a718d6e2706d8$var$initLoopVideos(body);
        // Wraps each h2 (and its eyebrow, if any) with its content in a
        // <section>. The section id comes from the eyebrow when there is one
        // (the short label meant for navigation) and otherwise from the
        // heading itself as a fallback.
        const h2s = Array.from(body.querySelectorAll('.case-section__title'));
        h2s.forEach((h2, i)=>{
            const eyebrowEl = $3f6a718d6e2706d8$var$getEyebrowFor(h2);
            const label = (eyebrowEl !== null && eyebrowEl !== void 0 ? eyebrowEl : h2).textContent.trim();
            const section = document.createElement('section');
            section.className = 'case-section';
            section.id = $3f6a718d6e2706d8$var$slugify(label);
            // The walk towards the next h2 must stop BEFORE that section's
            // eyebrow; otherwise the loop drags it into the current section as
            // one more paragraph, and getEyebrowFor() no longer finds it when
            // its turn comes.
            const next = h2s[i + 1];
            var _getEyebrowFor;
            const nextBoundary = next ? (_getEyebrowFor = $3f6a718d6e2706d8$var$getEyebrowFor(next)) !== null && _getEyebrowFor !== void 0 ? _getEyebrowFor : next : null;
            const siblings = [];
            let el = h2.nextElementSibling;
            while(el && el !== nextBoundary){
                siblings.push(el);
                el = el.nextElementSibling;
            }
            const anchor = eyebrowEl !== null && eyebrowEl !== void 0 ? eyebrowEl : h2;
            anchor.before(section);
            if (eyebrowEl) section.appendChild(eyebrowEl);
            section.appendChild(h2);
            siblings.forEach((s)=>section.appendChild(s));
        });
    } catch (err) {
        console.error('Error in fetchProjectContent:', err);
    }
    // Index, after wrapping the sections
    $3f6a718d6e2706d8$var$renderIndex();
    $3f6a718d6e2706d8$var$initBackToTop();
    // Related work, last, so a failure here does not affect the case study
    $3f6a718d6e2706d8$var$renderRelatedWork(project, allProjects);
    $3f6a718d6e2706d8$var$hide('case-loading');
    $3f6a718d6e2706d8$var$show('case-content');
}
function $3f6a718d6e2706d8$var$renderError() {
    $3f6a718d6e2706d8$var$hide('case-loading');
    $3f6a718d6e2706d8$var$show('case-error');
}
// ─── Bootstrap ──────────────────────────────────────
async function $3f6a718d6e2706d8$var$init() {
    const slug = $3f6a718d6e2706d8$var$getSlugFromURL();
    if (!slug) {
        $3f6a718d6e2706d8$var$renderError();
        return;
    }
    try {
        const projects = await (0, $0918ca489adad7b4$export$f0d2ca471cdb99b0)();
        const project = projects.find((p)=>p.slug === slug);
        if (!project) {
            $3f6a718d6e2706d8$var$renderError();
            return;
        }
        await $3f6a718d6e2706d8$var$renderCase(project, projects);
    } catch (err) {
        console.error('Error loading the project:', err);
        $3f6a718d6e2706d8$var$renderError();
    }
}
function $3f6a718d6e2706d8$export$cc3beac0a359ae22() {
    $3f6a718d6e2706d8$var$init();
}


/**
 * about.js — About page
 *
 * All the content lives in src/data/about.json: an object with one profile
 * per key (professional, personal…). A null profile does not exist yet and
 * is not shown. With more than one profile the selector is rendered;
 * switching profile renders the photo, intro, sections and index again.
 */ var $604ce967140339e2$exports = {};
$604ce967140339e2$exports = JSON.parse('{"professional":{"label":"Professional","image":{"src":"/media/about/profile.webp","alt":"Portrait of Laura Caballero"},"intro":["\uD83D\uDC4B\xa0Hello! I\'m Laura Caballero, a digital designer currently based in Asturias, Spain, and open to relocating. ","I trained in Design and Creative Technologies at the Universitat Polit\xe8cnica de Val\xe8ncia, and then specialised in User Interface Design.","I work between product design and digital branding: from research and structure through to interfaces, and the design systems that keep a product and its brand consistent, yet adaptable, across platforms and media."],"sections":[{"id":"experience","title":"Experience","type":"timeline","items":[{"role":"Graphic Design & Web Content Intern","start":"2025-05","end":"2026-04","organization":{"name":"Instituto Universitario de Restauraci\xf3n del Patrimonio","url":"https://www.uv.es/iupr"},"location":"Valencia, Spain \xb7 Part-time \xb7 On-site"},{"role":"Graphic Design Intern","start":"2024-08","end":"2024-11","organization":{"name":"End of Work","url":"https://www.endofwork.com.au/"},"location":"Sydney, Australia \xb7 On-site \xb7 Part-time"}]},{},{"id":"education","title":"Education","type":"timeline","items":[{"role":"Postgraduate Expert Diploma in User Interface Design (24 ECTS)","start":"2025-09","end":"2026-07","organization":{"name":"Universitat Polit\xe8cnica de Val\xe8ncia (UPV)"}},{"role":"Bachelor\'s Degree in Design and Creative Technologies","start":"2021-09","end":"2025-07","organization":{"name":"Universitat Polit\xe8cnica de Val\xe8ncia (UPV)"}}]},{"id":"merits","title":"Merits","type":"timeline","items":[{"role":"Erasmus+ KA131 Scholarship","start":"2024-07","end":"2025-01","organization":{"name":"University of Technology Sydney (UTS)"},"location":"Sydney, Australia","description":"Awarded for an exchange semester in the Bachelor of Design in Visual Communication."},{"role":"Erasmus+ Blended Intensive Programme (BIP)","start":"2024-01","end":"2024-02","organization":{"name":"HU University of Applied Sciences Utrecht"},"location":"Utrecht, Netherlands","description":"Participated in the European Creative Futures Programme."},{"role":"Amancio Ortega Foundation (FAO) Scholarship","start":"2019-09","end":"2020-06","organization":{"name":"Earl of March Secondary School"},"location":"Ottawa, Canada","description":"Awarded for a year of secondary study abroad (Grade 11)."}]},{"id":"languages","title":"Languages","type":"languages","items":[{"language":"Spanish","level":"Native"},{"language":"English","level":"Proficient (C2)","note":"Cambridge C1 Advanced, awarded at C2 level"},{"language":"German","level":"Elementary (A2)","note":"Official Language School (EOI)"}]}]},"personal":null}');




// "2025-05" → "May 2025". The CSS sets the capitals.
const $63b5e1fc97cd1f5d$var$dateFormat = new Intl.DateTimeFormat('en', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
});
// The content is ours, but it is escaped anyway: a "<" or an "&" in the
// JSON must not break the markup
function $63b5e1fc97cd1f5d$var$escapeHTML(text = '') {
    return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $63b5e1fc97cd1f5d$var$formatDate(value) {
    if (!value) return 'Present';
    const [year, month] = value.split('-').map(Number);
    return `<time datetime="${value}">${$63b5e1fc97cd1f5d$var$dateFormat.format(Date.UTC(year, month - 1))}</time>`;
}
// ─── Sections: one function per type ──────────────
function $63b5e1fc97cd1f5d$var$renderTimelineItem(item) {
    var _item_organization;
    const { name: name, url: url } = (_item_organization = item.organization) !== null && _item_organization !== void 0 ? _item_organization : {};
    const organization = url ? `<a class="about-item__link" href="${$63b5e1fc97cd1f5d$var$escapeHTML(url)}" target="_blank" rel="noopener noreferrer">${$63b5e1fc97cd1f5d$var$escapeHTML(name)}</a>` : $63b5e1fc97cd1f5d$var$escapeHTML(name);
    const location = item.location ? ` \xb7 ${$63b5e1fc97cd1f5d$var$escapeHTML(item.location)}` : '';
    return `
    <li class="about-section__item">
      <details class="about-item">
        <summary class="about-item__summary">
          <span class="about-item__role">${$63b5e1fc97cd1f5d$var$escapeHTML(item.role)}</span>
          <span class="about-item__dates">${$63b5e1fc97cd1f5d$var$formatDate(item.start)} \u{2013} ${$63b5e1fc97cd1f5d$var$formatDate(item.end)}</span>
          <span class="about-item__icon" aria-hidden="true"></span>
        </summary>
        ${name ? `<p class="about-item__organization">${organization}${location}</p>` : ''}
        ${item.description ? `<p class="about-item__description">${$63b5e1fc97cd1f5d$var$escapeHTML(item.description)}</p>` : ''}
      </details>
    </li>
  `;
}
function $63b5e1fc97cd1f5d$var$renderListItem(item) {
    return `<li class="about-section__item about-entry"><span class="about-entry__name">${$63b5e1fc97cd1f5d$var$escapeHTML(item)}</span></li>`;
}
function $63b5e1fc97cd1f5d$var$renderLanguageItem(item) {
    return `
    <li class="about-section__item about-entry">
      <span class="about-entry__name">${$63b5e1fc97cd1f5d$var$escapeHTML(item.language)}</span>
      <span class="about-entry__level">${$63b5e1fc97cd1f5d$var$escapeHTML(item.level)}</span>
      ${item.note ? `<span class="about-entry__note">${$63b5e1fc97cd1f5d$var$escapeHTML(item.note)}</span>` : ''}
    </li>
  `;
}
const $63b5e1fc97cd1f5d$var$itemRenderers = {
    timeline: $63b5e1fc97cd1f5d$var$renderTimelineItem,
    list: $63b5e1fc97cd1f5d$var$renderListItem,
    languages: $63b5e1fc97cd1f5d$var$renderLanguageItem
};
function $63b5e1fc97cd1f5d$var$renderSection(section) {
    var _section_items;
    const renderItem = $63b5e1fc97cd1f5d$var$itemRenderers[section.type];
    if (!renderItem || !((_section_items = section.items) === null || _section_items === void 0 ? void 0 : _section_items.length)) return '';
    // role="list": Safari stops announcing a ul without bullets as a list
    return `
    <section class="about-section" id="${$63b5e1fc97cd1f5d$var$escapeHTML(section.id)}" aria-labelledby="${$63b5e1fc97cd1f5d$var$escapeHTML(section.id)}-title">
      <h2 class="about-section__title" id="${$63b5e1fc97cd1f5d$var$escapeHTML(section.id)}-title">${$63b5e1fc97cd1f5d$var$escapeHTML(section.title)}</h2>
      <ul class="about-section__list" role="list">
        ${section.items.map(renderItem).join('')}
      </ul>
    </section>
  `;
}
// ─── Side index ────────────────────────────────────
// Marks the link of the visible section. Same rule as the case study
// index: the active section is the last one whose title has passed a line
// at ~35% of the window height. It reads the DOM on every call, so it
// works for any profile without registering the listener again.
function $63b5e1fc97cd1f5d$var$updateActiveLink() {
    var _headers__closest, _headers_;
    const links = document.querySelectorAll('#about-index .section-index__link');
    const headers = document.querySelectorAll('.about-section__title');
    const headerEl = document.querySelector('.site-nav');
    const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 64;
    const triggerLine = headerHeight + window.innerHeight * 0.35;
    var _headers__closest_id;
    let current = (_headers__closest_id = (_headers_ = headers[0]) === null || _headers_ === void 0 ? void 0 : (_headers__closest = _headers_.closest('section')) === null || _headers__closest === void 0 ? void 0 : _headers__closest.id) !== null && _headers__closest_id !== void 0 ? _headers__closest_id : null;
    headers.forEach((h)=>{
        if (h.getBoundingClientRect().top <= triggerLine) current = h.closest('section').id;
    });
    // At the end of the page the last (short) section never reaches the
    // line: if the page cannot scroll further, it is the active one
    const atEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 1;
    if (atEnd && headers.length) current = headers[headers.length - 1].closest('section').id;
    links.forEach((link)=>{
        if (link.getAttribute('href') === `#${current}`) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
    });
}
function $63b5e1fc97cd1f5d$var$renderIndex(sections) {
    const indexNav = document.getElementById('about-index');
    if (!indexNav) return;
    // The same sections that are rendered: no items, no section and no link
    const visible = sections.filter((s)=>{
        var _s_items;
        return $63b5e1fc97cd1f5d$var$itemRenderers[s.type] && ((_s_items = s.items) === null || _s_items === void 0 ? void 0 : _s_items.length);
    });
    indexNav.innerHTML = `
    <ul class="section-index__list">
      ${visible.map((s)=>`
        <li class="section-index__item">
          <a href="#${$63b5e1fc97cd1f5d$var$escapeHTML(s.id)}" class="section-index__link">${$63b5e1fc97cd1f5d$var$escapeHTML(s.title)}</a>
        </li>
      `).join('')}
    </ul>
  `;
    $63b5e1fc97cd1f5d$var$updateActiveLink();
}
// ─── Profile ───────────────────────────────────────
// sizes of the photo: columns 1 to 3 of the grid from 1025px (368px at most
// inside .container); below that, one column with the photo at half width
// (about.css). Approximate on purpose: the browser rounds up.
const $63b5e1fc97cd1f5d$var$PHOTO_SIZES = '(min-width: 1568px) 368px, (min-width: 1025px) calc(25vw - 24px), calc(50vw - 24px)';
function $63b5e1fc97cd1f5d$var$renderProfile(profile) {
    var _profile_image;
    const image = document.getElementById('about-image');
    if (image) image.innerHTML = ((_profile_image = profile.image) === null || _profile_image === void 0 ? void 0 : _profile_image.src) ? `<img class="about__image" ${(0, $0918ca489adad7b4$export$5696459faf0975d)($63b5e1fc97cd1f5d$var$escapeHTML(profile.image.src), $63b5e1fc97cd1f5d$var$PHOTO_SIZES)} alt="${$63b5e1fc97cd1f5d$var$escapeHTML(profile.image.alt)}" decoding="async">` : '';
    const intro = document.getElementById('about-intro');
    var _profile_intro;
    if (intro) // parseInline: bold, italics and links only; no extra <p>
    intro.innerHTML = ((_profile_intro = profile.intro) !== null && _profile_intro !== void 0 ? _profile_intro : []).map((p)=>`<p class="about__text">${(0, $25a11d61f10b4ce2$exports.marked).parseInline(p)}</p>`).join('');
    var _profile_sections;
    const sections = (_profile_sections = profile.sections) !== null && _profile_sections !== void 0 ? _profile_sections : [];
    const container = document.getElementById('about-sections');
    if (container) container.innerHTML = sections.map($63b5e1fc97cd1f5d$var$renderSection).join('');
    $63b5e1fc97cd1f5d$var$renderIndex(sections);
}
// ─── Profile selector ──────────────────────────────
function $63b5e1fc97cd1f5d$var$renderSelector(profiles) {
    const group = document.getElementById('about-profiles');
    if (!group || profiles.length < 2) return;
    group.innerHTML = profiles.map(([key, profile], i)=>`
    <button type="button" class="button-primary" data-profile="${$63b5e1fc97cd1f5d$var$escapeHTML(key)}" aria-pressed="${i === 0}">
      ${$63b5e1fc97cd1f5d$var$escapeHTML(profile.label)}
    </button>
  `).join('');
    group.hidden = false;
    // The buttons are not rendered again when the profile changes: focus
    // stays on the pressed button and aria-pressed tells which one is active
    group.addEventListener('click', (e)=>{
        const btn = e.target.closest('[data-profile]');
        if (!btn || btn.getAttribute('aria-pressed') === 'true') return;
        group.querySelectorAll('[data-profile]').forEach((b)=>{
            b.setAttribute('aria-pressed', String(b === btn));
        });
        $63b5e1fc97cd1f5d$var$renderProfile((0, (/*@__PURE__*/$parcel$interopDefault($604ce967140339e2$exports)))[btn.dataset.profile]);
    });
}
function $63b5e1fc97cd1f5d$export$2c710841228ddcf1() {
    const profiles = Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($604ce967140339e2$exports)))).filter(([, profile])=>profile);
    if (!profiles.length) return;
    $63b5e1fc97cd1f5d$var$renderSelector(profiles);
    $63b5e1fc97cd1f5d$var$renderProfile(profiles[0][1]);
    window.addEventListener('scroll', $63b5e1fc97cd1f5d$var$updateActiveLink, {
        passive: true
    });
}


/**
 * archive.js — Archive page
 *
 * Tag filters (multiple selection), list/grid view, and a preview of
 * the hero image that follows the cursor in the list view.
 */ 
const $29ff809da19519d2$var$DEFAULT_VIEW = 'list';
const $29ff809da19519d2$var$state = {
    projects: [],
    activeTags: new Set(),
    view: $29ff809da19519d2$var$DEFAULT_VIEW
};
const $29ff809da19519d2$var$canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
// ─── Filtering ────────────────────────────────────
function $29ff809da19519d2$var$getVisibleProjects() {
    if ($29ff809da19519d2$var$state.activeTags.size === 0) return $29ff809da19519d2$var$state.projects;
    return $29ff809da19519d2$var$state.projects.filter((p)=>p.tags.some((tag)=>$29ff809da19519d2$var$state.activeTags.has(tag)));
}
// ─── Filters ──────────────────────────────────────
function $29ff809da19519d2$var$renderFilters(tags) {
    const container = document.getElementById('archive-filters');
    if (!container) return;
    container.innerHTML = [
        `<button type="button" class="button-primary archive__filter archive__filter--all" data-tag="all" aria-pressed="true">All</button>`,
        ...tags.map((tag)=>`<button type="button" class="button-primary archive__filter" data-tag="${tag}" aria-pressed="false">${tag}</button>`)
    ].join('');
    container.addEventListener('click', (e)=>{
        const btn = e.target.closest('[data-tag]');
        if (!btn) return;
        const { tag: tag } = btn.dataset;
        if (tag === 'all') $29ff809da19519d2$var$state.activeTags.clear();
        else if ($29ff809da19519d2$var$state.activeTags.has(tag)) $29ff809da19519d2$var$state.activeTags.delete(tag);
        else $29ff809da19519d2$var$state.activeTags.add(tag);
        $29ff809da19519d2$var$syncFilterButtons();
        $29ff809da19519d2$var$renderProjects();
    });
}
function $29ff809da19519d2$var$syncFilterButtons() {
    document.querySelectorAll('#archive-filters [data-tag]').forEach((btn)=>{
        const { tag: tag } = btn.dataset;
        const pressed = tag === 'all' ? $29ff809da19519d2$var$state.activeTags.size === 0 : $29ff809da19519d2$var$state.activeTags.has(tag);
        btn.setAttribute('aria-pressed', String(pressed));
    });
}
// ─── View switch ──────────────────────────────────
function $29ff809da19519d2$var$initViewToggle() {
    const buttons = document.querySelectorAll('button[data-view]');
    buttons.forEach((btn)=>{
        btn.setAttribute('aria-pressed', String(btn.dataset.view === $29ff809da19519d2$var$state.view));
        btn.addEventListener('click', ()=>{
            if ($29ff809da19519d2$var$state.view === btn.dataset.view) return;
            $29ff809da19519d2$var$state.view = btn.dataset.view;
            buttons.forEach((b)=>b.setAttribute('aria-pressed', String(b === btn)));
            $29ff809da19519d2$var$hidePreview();
            $29ff809da19519d2$var$renderProjects();
        });
    });
}
// ─── Render ───────────────────────────────────────
// sizes of the grid cards: 3 columns from 1025px (496px at most inside
// .container), 2 from 769px and 1 below (archive.css). The cursor preview
// is 28.25rem wide (cursor-preview.css). Approximate on purpose.
const $29ff809da19519d2$var$CARD_SIZES = '(min-width: 1568px) 496px, (min-width: 1025px) calc(33.33vw - 27px), (min-width: 769px) calc(50vw - 32px), calc(100vw - 48px)';
const $29ff809da19519d2$var$PREVIEW_SIZES = '28.25rem';
// Projects without a case study: same row/card, but without a link
function $29ff809da19519d2$var$listItem(p) {
    var _srcsetFor;
    const available = (0, $0918ca489adad7b4$export$c8b627156f9fcdf5)(p.slug);
    const tag = available ? 'a' : 'div';
    const href = available ? ` href="/project/${p.slug}/"` : '';
    var _srcsetFor_srcset, _p_claim;
    return `
    <li>
      <${tag} class="archive-row${available ? '' : ' archive-row--coming-soon'}"${href} data-thumbnail="${(0, $0918ca489adad7b4$export$e8c55a0bcbd53ecb)(p)}" data-srcset="${(_srcsetFor_srcset = (_srcsetFor = (0, $0918ca489adad7b4$export$cc734a7c9455c1b3)((0, $0918ca489adad7b4$export$e8c55a0bcbd53ecb)(p))) === null || _srcsetFor === void 0 ? void 0 : _srcsetFor.srcset) !== null && _srcsetFor_srcset !== void 0 ? _srcsetFor_srcset : ''}">
        <h2 class="archive-row__title">${p.title}</h2>
        <p class="archive-row__claim">${(_p_claim = p.claim) !== null && _p_claim !== void 0 ? _p_claim : p.summary}${available ? '' : '<span class="visually-hidden"> (case study coming soon)</span>'}</p>
        <time class="archive-row__year" datetime="${p.year}">${p.year}</time>
      </${tag}>
    </li>
  `;
}
function $29ff809da19519d2$var$gridItem(p) {
    const available = (0, $0918ca489adad7b4$export$c8b627156f9fcdf5)(p.slug);
    const chipText = available ? 'See work' : 'Coming soon!';
    const tag = available ? 'a' : 'div';
    const href = available ? ` href="/project/${p.slug}/"` : '';
    return `
    <li>
      <${tag} class="archive-card${available ? '' : ' archive-card--coming-soon'}"${href}>
        <figure class="archive-card__figure">
          <img class="archive-card__image" ${(0, $0918ca489adad7b4$export$5696459faf0975d)((0, $0918ca489adad7b4$export$e8c55a0bcbd53ecb)(p), $29ff809da19519d2$var$CARD_SIZES)} alt="" loading="lazy" decoding="async">
          <span class="chip${available ? '' : ' chip--coming-soon'}"${available ? ' aria-hidden="true"' : ''}>
            <span class="chip__label">${chipText}</span>
          </span>
        </figure>
        <h2 class="archive-card__title">${p.title}</h2>
        <p class="archive-card__tags">${p.tags.join(', ')}</p>
      </${tag}>
    </li>
  `;
}
function $29ff809da19519d2$var$renderProjects() {
    const list = document.getElementById('archive-projects');
    const status = document.getElementById('archive-status');
    if (!list) return;
    const visible = $29ff809da19519d2$var$getVisibleProjects();
    const template = $29ff809da19519d2$var$state.view === 'grid' ? $29ff809da19519d2$var$gridItem : $29ff809da19519d2$var$listItem;
    list.dataset.view = $29ff809da19519d2$var$state.view;
    list.innerHTML = visible.length ? visible.map(template).join('') : `<li class="archive__empty">No projects match these filters.</li>`;
    if (status) status.textContent = `${visible.length} ${visible.length === 1 ? 'project' : 'projects'}`;
}
// ─── Cursor preview (list view) ───────────────────
// The coordinates go in custom properties (--x, --y): it is the only style
// written from JS, because it depends on the pointer position.
let $29ff809da19519d2$var$previewEl = null;
let $29ff809da19519d2$var$previewImg = null;
function $29ff809da19519d2$var$hidePreview() {
    $29ff809da19519d2$var$previewEl === null || $29ff809da19519d2$var$previewEl === void 0 ? void 0 : $29ff809da19519d2$var$previewEl.classList.remove('is-visible');
}
function $29ff809da19519d2$var$initCursorPreview() {
    $29ff809da19519d2$var$previewEl = document.querySelector('.cursor-preview');
    $29ff809da19519d2$var$previewImg = $29ff809da19519d2$var$previewEl === null || $29ff809da19519d2$var$previewEl === void 0 ? void 0 : $29ff809da19519d2$var$previewEl.querySelector('.cursor-preview__image');
    const list = document.getElementById('archive-projects');
    if (!$29ff809da19519d2$var$previewEl || !$29ff809da19519d2$var$previewImg || !list) return;
    let x = 0;
    let y = 0;
    let frame = null;
    /** Places the preview next to the cursor (cursor-preview.css reads the position) */ function positionPreview() {
        $29ff809da19519d2$var$previewEl.style.setProperty('--x', `${x}px`);
        $29ff809da19519d2$var$previewEl.style.setProperty('--y', `${y}px`);
    }
    list.addEventListener('mouseover', (e)=>{
        if ($29ff809da19519d2$var$state.view !== 'list' || !$29ff809da19519d2$var$canHover.matches) return;
        const row = e.target.closest('[data-thumbnail]');
        if (!row) return;
        // Positions it before showing it, so it does not appear in the previous spot
        x = e.clientX;
        y = e.clientY;
        positionPreview();
        // srcset first, so the browser picks the preview width before loading
        if ($29ff809da19519d2$var$previewImg.getAttribute('src') !== row.dataset.thumbnail) {
            $29ff809da19519d2$var$previewImg.sizes = $29ff809da19519d2$var$PREVIEW_SIZES;
            $29ff809da19519d2$var$previewImg.srcset = row.dataset.srcset;
            $29ff809da19519d2$var$previewImg.src = row.dataset.thumbnail;
        }
        $29ff809da19519d2$var$previewEl.classList.add('is-visible');
    });
    list.addEventListener('mousemove', (e)=>{
        if ($29ff809da19519d2$var$state.view !== 'list') return;
        x = e.clientX;
        y = e.clientY;
        if (frame) return;
        frame = requestAnimationFrame(()=>{
            positionPreview();
            frame = null;
        });
    });
    list.addEventListener('mouseleave', $29ff809da19519d2$var$hidePreview);
}
async function $29ff809da19519d2$export$d10d2f53b528c62e() {
    try {
        const projects = await (0, $0918ca489adad7b4$export$f0d2ca471cdb99b0)();
        $29ff809da19519d2$var$state.projects = [
            ...projects
        ].sort((a, b)=>Number(b.year) - Number(a.year));
        $29ff809da19519d2$var$renderFilters((0, $0918ca489adad7b4$export$bca74923a5f13e55)(projects));
        $29ff809da19519d2$var$initViewToggle();
        $29ff809da19519d2$var$initCursorPreview();
        $29ff809da19519d2$var$renderProjects();
    } catch (err) {
        console.error(err);
        const list = document.getElementById('archive-projects');
        if (list) list.innerHTML = `<li class="archive__empty" role="alert">Projects could not be loaded.</li>`;
    }
}


var $57550f45a57008d4$exports = {};
$57550f45a57008d4$exports = "<main>\n  <section class=archive aria-labelledby=archive-title>\n    <h1 id=archive-title class=visually-hidden>Project archive</h1>\n\n    <div class=archive__toolbar>\n      <div class=archive__filters id=archive-filters role=group aria-label=\"Filter projects by category\"></div>\n\n      <div class=archive__views role=group aria-label=\"View mode\">\n        <button type=button class=\"view-toggle view-toggle--list\" data-view=list aria-pressed=false>\n          <span class=visually-hidden>List view</span>\n        </button>\n        <button type=button class=\"view-toggle view-toggle--grid\" data-view=grid aria-pressed=false>\n          <span class=visually-hidden>Grid view</span>\n        </button>\n      </div>\n    </div>\n\n    <p class=visually-hidden id=archive-status aria-live=polite></p>\n\n    <ul class=archive__projects id=archive-projects></ul>\n  </section>\n\n  <div class=cursor-preview aria-hidden=true>\n    <img class=cursor-preview__image alt width=452 height=288 decoding=async>\n  </div>\n</main>";


var $3ce70c45118301bb$exports = {};
$3ce70c45118301bb$exports = "<main>\n\n    \n    <div id=case-loading aria-live=polite aria-busy=true>\n      <div class=container>\n        <p>Loading...</p>\n      </div>\n    </div>\n\n    \n    <div id=case-error hidden>\n      <div class=container>\n        <p role=alert>Project not found. <a href=/>Back to home</a></p>\n      </div>\n    </div>\n\n    \n    <div id=case-content class=case hidden>\n\n      \n      <div class=case__hero></div>\n\n      \n      <div class=case__layout>\n\n        \n        <div class=case__sidebar>\n          <div class=case__sidebar-inner>\n            <header class=case-header>\n              <h1 id=case-title class=case-header__title></h1>\n              <p id=case-client class=case-header__client></p>\n              <div id=case-tags class=case-header__tags></div>\n            </header>\n            <nav class=section-index aria-label=\"Project index\"></nav>\n          </div>\n        </div>\n\n        \n        <div class=case__main>\n\n          \n          <section id=overview class=case-overview>\n            <h2 class=visually-hidden>Overview</h2>\n\n            <p id=case-summary class=case-overview__summary></p>\n\n            <dl class=case-meta>\n              <div class=case-meta__item>\n                <dt class=case-meta__label>Timeline</dt>\n                <dd id=case-timeline class=case-meta__value></dd>\n              </div>\n              <div class=case-meta__item>\n                <dt class=case-meta__label>Roles</dt>\n                <dd class=case-meta__value><ul class=case-meta__list id=case-role></ul></dd>\n              </div>\n              <div class=case-meta__item>\n                <dt class=case-meta__label>Team</dt>\n                <dd class=case-meta__value><ul class=case-meta__list id=case-team></ul></dd>\n              </div>\n              <div class=case-meta__item>\n                <dt class=case-meta__label>Tools</dt>\n                <dd class=case-meta__value><ul class=case-meta__list id=case-tools></ul></dd>\n              </div>\n            </dl>\n          </section>\n\n          \n          <article id=case-body class=case__content></article>\n        </div>\n\n      </div>\n\n      <aside class=related-work aria-labelledby=related-work-title hidden></aside>\n\n      \n      <a href=#top class=back-to-top><span class=visually-hidden>Back to top</span></a>\n    </div>\n\n  </main>\n";


var $4b84540ff6b6971c$exports = {};
$4b84540ff6b6971c$exports = "<main>\n  <div class=about>\n\n    <h1 class=visually-hidden>About</h1>\n\n    \n    <div class=about__profiles id=about-profiles role=group aria-label=\"View profile\" hidden></div>\n\n    \n    <div class=about__layout>\n      <div class=about__media id=about-image></div>\n      <div class=about__intro id=about-intro></div>\n      <nav class=\"about__index section-index\" id=about-index aria-label=\"About sections\"></nav>\n      <div class=about__sections id=about-sections></div>\n    </div>\n\n  </div>\n\n  </main>\n";


const $086276b712d2d375$var$path = window.location.pathname;
const $086276b712d2d375$var$main = document.querySelector('main');
// ─── Loads the page HTML and runs its module ──────────────────
function $086276b712d2d375$var$loadPage(html, initFn) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    $086276b712d2d375$var$main.innerHTML = doc.querySelector('main').innerHTML;
    initFn();
}
// ─── Router ───────────────────────────────────────────────────
if ($086276b712d2d375$var$path.startsWith('/project/')) {
    // The case study page (URL /project/<slug>/) manages its own width
    $086276b712d2d375$var$main.classList.remove('container');
    $086276b712d2d375$var$loadPage((0, (/*@__PURE__*/$parcel$interopDefault($3ce70c45118301bb$exports))), (0, $3f6a718d6e2706d8$export$cc3beac0a359ae22));
} else if ($086276b712d2d375$var$path.startsWith('/archive')) {
    document.title = "Archive \u2014 Laura Caballero Garc\xeda";
    $086276b712d2d375$var$main.classList.add('container');
    $086276b712d2d375$var$loadPage((0, (/*@__PURE__*/$parcel$interopDefault($57550f45a57008d4$exports))), (0, $29ff809da19519d2$export$d10d2f53b528c62e));
} else if ($086276b712d2d375$var$path.startsWith('/about')) {
    document.title = "About \u2014 Laura Caballero Garc\xeda";
    $086276b712d2d375$var$main.classList.add('container');
    $086276b712d2d375$var$loadPage((0, (/*@__PURE__*/$parcel$interopDefault($4b84540ff6b6971c$exports))), (0, $63b5e1fc97cd1f5d$export$2c710841228ddcf1));
} else {
    // Home page
    $086276b712d2d375$var$main.classList.add('container');
    (0, $c989ba879ed802fa$export$8a39893ac75b3cff)();
}


//# sourceMappingURL=pages.a3bc7d4a.js.map
